var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatients2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-40"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-40",
    cx: 250,
    cy: 315.47,
    rx: 243.72,
    ry: 140.71,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-40",
    d: "M377.87,182.91l105.51,61a.82.82,0,0,1,0,1.56l-30.19,17.42a3,3,0,0,1-2.71,0L345,201.89a.83.83,0,0,1,0-1.56l30.19-17.42A3,3,0,0,1,377.87,182.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-40",
    d: "M342.76,484.64l87.13-50.08c2-1.14,2-3,0-4.13L239,320.74a8,8,0,0,0-7.18,0l-87.14,50.08c-2,1.14-2,3,0,4.12l190.89,109.7A8,8,0,0,0,342.76,484.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-40",
    d: "M84.76,377.56,22,341.48c-2-1.13-2-3,0-4.12L203.64,233.08a8,8,0,0,1,7.18,0l62.81,36.07c2,1.14,2,3,0,4.12L91.94,377.56A8,8,0,0,1,84.76,377.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-40",
    d: "M320.57,297.89l-31.29-18a1.08,1.08,0,0,1,0-2.05L330.81,254a4,4,0,0,1,3.58,0l31.28,18a1.08,1.08,0,0,1,0,2.05l-41.53,23.83A4,4,0,0,1,320.57,297.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-40",
    cx: 140.07,
    cy: 434.72,
    rx: 34.16,
    ry: 19.72,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-40",
    cx: 409.42,
    cy: 308.16,
    rx: 44.66,
    ry: 25.78,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.77,250.45h-6.41l1,6.26h0a1.15,1.15,0,0,0,.62.77,3.41,3.41,0,0,0,3.11,0,1.15,1.15,0,0,0,.62-.77h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.77,250.45h-6.41l1,6.26h0a1.15,1.15,0,0,0,.62.77,3.41,3.41,0,0,0,3.11,0,1.15,1.15,0,0,0,.62-.77h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.21,197.62h-6.42l1,6.26h0a1.18,1.18,0,0,0,.62.77,3.45,3.45,0,0,0,3.1,0,1.12,1.12,0,0,0,.62-.77h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.21,197.62h-6.42l1,6.26h0a1.18,1.18,0,0,0,.62.77,3.45,3.45,0,0,0,3.1,0,1.12,1.12,0,0,0,.62-.77h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.52,239.61h-6.41l1,6.26h0a1.15,1.15,0,0,0,.62.77,3.41,3.41,0,0,0,3.11,0,1.15,1.15,0,0,0,.62-.77h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.52,239.61h-6.41l1,6.26h0a1.15,1.15,0,0,0,.62.77,3.41,3.41,0,0,0,3.11,0,1.15,1.15,0,0,0,.62-.77h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.1 171.81 476.1 242.38 452.53 256.01 452.53 185.44 476.1 171.81",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.53 256.01 353.93 199.11 353.93 128.54 452.53 185.44 452.53 256.01",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.46 238.65 421.2 237.92 421.2 167.35 422.46 168.08 422.46 238.65",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.45 213.82 378.19 213.09 378.19 142.52 379.45 143.25 379.45 213.82",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.59,129a1,1,0,0,1,.56-.79l25.68-14.84a3,3,0,0,1,2.71,0l100,57.69a1,1,0,0,1,.56.78v1.8a1,1,0,0,1-.56.78l-25.69,14.85a3,3,0,0,1-2.71,0l-100-57.72a.94.94,0,0,1-.56-.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.13,171.81v1.8a1,1,0,0,1-.56.78l-25.69,14.85a2.7,2.7,0,0,1-1.35.33l-22.18-30.78,18.45-5.52L479.57,171A1,1,0,0,1,480.13,171.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.54,113.34l100,57.69a.82.82,0,0,1,0,1.56l-25.69,14.85a3,3,0,0,1-2.71,0l-100-57.69a.83.83,0,0,1,0-1.57l25.68-14.84A3,3,0,0,1,379.54,113.34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.91,190.4c0,.44-1.3,0-2.9-.89l-3.84-2.2c-1.6-.93-2.91-2-2.91-2.48V184l9.65,5.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.27,150.22c0,.44-1.3,0-2.91-.89l-3.83-2.21c-1.61-.92-2.91-2-2.91-2.47v-.79l9.65,5.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.62,174.67c0,.44-1.3,0-2.91-.89l-3.83-2.21c-1.61-.92-2.91-2-2.91-2.47v-.79l9.65,5.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.62,191.39c0,.43-1.3,0-2.91-.9l-3.83-2.2c-1.61-.93-2.91-2-2.91-2.48V185l9.65,5.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.62,215.39c0,.43-1.3,0-2.91-.89l-3.83-2.21c-1.61-.93-2.91-2-2.91-2.47V209l9.65,5.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.82 169.56 422.03 194.5 422.03 195.89 378.82 170.95 378.82 169.56",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.82 193.56 422.03 218.5 422.03 219.9 378.82 194.95 378.82 193.56",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shelf--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.65,74.24V72.5h0A.6.6,0,0,1,337,72l10.45-6a1.82,1.82,0,0,1,1.61,0l30,17.35a.6.6,0,0,1,.35.46h0v1.74h0a.6.6,0,0,1-.35.47l-10.45,6a1.76,1.76,0,0,1-1.61,0L337,74.71a.62.62,0,0,1-.35-.47Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.1,84.28l-10.45,6a1.76,1.76,0,0,1-1.61,0L337,73a.49.49,0,0,1,0-.92l10.45-6a1.82,1.82,0,0,1,1.61,0l30,17.35A.49.49,0,0,1,379.1,84.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.85,90.5v1.74a1.6,1.6,0,0,0,.8-.19l10.45-6a.6.6,0,0,0,.35-.47h0V83.81h0a.49.49,0,0,0-.07-.19c.12.22,0,.48-.28.66l-10.45,6A1.6,1.6,0,0,1,367.85,90.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.32,72.42a3.86,3.86,0,0,0-3.38,0c-.94.53-.94,1.37,0,1.89a3.79,3.79,0,0,0,3.38,0C351.25,73.79,351.25,73,350.32,72.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.9,63.16l0,0a2.22,2.22,0,0,1-.38-2.31,6.21,6.21,0,0,0,.29-.81c.13-.54,0-1.45.77-1.45s.61.9.76,1.45a5.36,5.36,0,0,0,.29.77,2.25,2.25,0,0,1-.39,2.38h0a.42.42,0,0,0-.12.3h0a.45.45,0,0,0,.32.42,2.65,2.65,0,0,1,.49.2,1,1,0,0,1,.56.78l.41,8.2c0,.48-.44,1-1.31,1.21a3.69,3.69,0,0,1-2,0c-.87-.26-1.3-.73-1.3-1.21l.41-8.2a1,1,0,0,1,.56-.78,2.39,2.39,0,0,1,.49-.2.44.44,0,0,0,.31-.42h0A.44.44,0,0,0,347.9,63.16Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.9,63.16l0,0a2.22,2.22,0,0,1-.38-2.31,6.21,6.21,0,0,0,.29-.81c.13-.54,0-1.45.77-1.45s.61.9.76,1.45a5.36,5.36,0,0,0,.29.77,2.25,2.25,0,0,1-.39,2.38h0a.42.42,0,0,0-.12.3h0a.45.45,0,0,0,.32.42,2.65,2.65,0,0,1,.49.2,1,1,0,0,1,.56.78l.41,8.2c0,.48-.44,1-1.31,1.21a3.69,3.69,0,0,1-2,0c-.87-.26-1.3-.73-1.3-1.21l.41-8.2a1,1,0,0,1,.56-.78,2.39,2.39,0,0,1,.49-.2.44.44,0,0,0,.31-.42h0A.44.44,0,0,0,347.9,63.16Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.2,72.11a3.64,3.64,0,0,0-3.28,0,1,1,0,0,0,0,1.9,3.64,3.64,0,0,0,3.28,0A1,1,0,0,0,350.2,72.11Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,74.37a3.94,3.94,0,0,1-.47-.1c-.87-.26-1.3-.73-1.3-1.21l.41-8.2a1,1,0,0,1,.56-.78,2.39,2.39,0,0,1,.49-.2.44.44,0,0,0,.31-.42c0,.33,0,.45-.32.64s-.79.17-.87,1.21-.35,7-.35,7.53S346.61,73.93,348,74.37Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.64,73.07l.3-6h0a.8.8,0,0,1,.48-.66,2.54,2.54,0,0,1,2.28,0,.81.81,0,0,1,.47.66h0l.3,6a.4.4,0,0,1,0,.15,1.11,1.11,0,0,1-.53.6,3,3,0,0,1-2.7,0,1.07,1.07,0,0,1-.53-.6A.83.83,0,0,1,346.64,73.07Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.91,72.26a3,3,0,0,0-2.7,0,.82.82,0,0,0,0,1.56,3,3,0,0,0,2.7,0A.83.83,0,0,0,349.91,72.26Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,73.64l.34-7.16.09-.06.37,0-.37,7.46-.19-.09A1.66,1.66,0,0,1,347,73.64Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,66.53l.23,0L348,74.08a1.67,1.67,0,0,1-.32-.08Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.36,73.08c0-.69,0-3.61-.14-5.65l.07-1.19a1.68,1.68,0,0,1,.41.17.81.81,0,0,1,.47.66h0l.3,6a.4.4,0,0,1,0,.15,1.11,1.11,0,0,1-.53.6,3,3,0,0,1-2.7,0C348.36,74.12,349.4,73.78,349.36,73.08Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.7,66.41a2.54,2.54,0,0,0-2.28,0,.7.7,0,0,0,0,1.32,2.54,2.54,0,0,0,2.28,0A.7.7,0,0,0,349.7,66.41Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.7,66.41a2.54,2.54,0,0,0-2.28,0,.7.7,0,0,0,0,1.32,2.54,2.54,0,0,0,2.28,0A.7.7,0,0,0,349.7,66.41Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.74,71.48a3.94,3.94,0,0,1-1.71-.37,1.09,1.09,0,0,1-.65-.89l.14-2.72a1,1,0,0,0,.61.82,3.63,3.63,0,0,0,1.61.34Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.56,71.59a3.08,3.08,0,0,1-1.54-.37,1.08,1.08,0,0,1-.64-.89l.13-2.74a1,1,0,0,0,.6.84,3,3,0,0,0,1.45.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,72.86c0-.46-.27-6.84-.34-7.59s-.34-.91-.84-1.29a.57.57,0,0,1-.07-.91,1.8,1.8,0,0,0,.51-1.83,9.06,9.06,0,0,1-.41-1.68c-.07-.79-.28-1-.57-.94a.62.62,0,0,1,.29-.06c.75,0,.61.9.76,1.45a5.36,5.36,0,0,0,.29.77,2.25,2.25,0,0,1-.39,2.38.42.42,0,0,0-.12.3.45.45,0,0,0,.32.42,2.65,2.65,0,0,1,.49.2,1,1,0,0,1,.56.78l.41,8.2c0,.48-.44,1-1.31,1.21a3.69,3.69,0,0,1-2,0l-.35-.13C349.33,74.72,350,73.33,350,72.86Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.64,61a5.86,5.86,0,0,0,.26-.57,3.16,3.16,0,0,0,.12-.8c0-.09,0-.3.12-.35s.14,0,.16.11a3.3,3.3,0,0,1,.08,1,3.68,3.68,0,0,1-.28.85,3.28,3.28,0,0,0-.08,1,.32.32,0,0,1,0,.14.14.14,0,0,1-.11.07.23.23,0,0,1-.1-.07.76.76,0,0,1-.18-.25,1.41,1.41,0,0,1,0-1.15Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.42,67.73a.7.7,0,0,1,0-1.32,1.78,1.78,0,0,1,.4-.17c-1.37.51-.59,1.68.74,1.65a1.9,1.9,0,0,0,1.57-.61,1,1,0,0,1-.43.45A2.54,2.54,0,0,1,347.42,67.73Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.75,72.06a1.14,1.14,0,0,0,0-2.17,4.22,4.22,0,0,0-3.79,0,1.14,1.14,0,0,0,0,2.17A4.22,4.22,0,0,0,345.75,72.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.86,64.56a2.16,2.16,0,0,1,.34-.17.59.59,0,0,0,.38-.55V62.67h2.18v1.17a.61.61,0,0,0,.38.55,1.89,1.89,0,0,1,.35.17,1.28,1.28,0,0,1,.75,1v5a1.28,1.28,0,0,1-.75,1,4,4,0,0,1-3.63,0,1.27,1.27,0,0,1-.76-1v-5A1.27,1.27,0,0,1,341.86,64.56Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.86,64.56a2.16,2.16,0,0,1,.34-.17.59.59,0,0,0,.38-.55V62.67h2.18v1.17a.61.61,0,0,0,.38.55,1.89,1.89,0,0,1,.35.17,1.28,1.28,0,0,1,.75,1v5a1.28,1.28,0,0,1-.75,1,4,4,0,0,1-3.63,0,1.27,1.27,0,0,1-.76-1v-5A1.27,1.27,0,0,1,341.86,64.56Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.49,71.7a1.1,1.1,0,0,0,0-2.08,4.07,4.07,0,0,0-3.63,0c-1,.57-1,1.5,0,2.08A4.07,4.07,0,0,0,345.49,71.7Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.49,71.7a1.1,1.1,0,0,0,0-2.08,4.07,4.07,0,0,0-3.63,0c-1,.57-1,1.5,0,2.08A4.07,4.07,0,0,0,345.49,71.7Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.51,67.08v3.41a1.09,1.09,0,0,0,.63.89l.25.12.05,0,.06,0a3.68,3.68,0,0,0,1.17.18A3.47,3.47,0,0,0,345,71.5h0l.25-.12a1.09,1.09,0,0,0,.63-.89V67.08a1.07,1.07,0,0,0-.63-.88,3.39,3.39,0,0,0-3.07,0A1.07,1.07,0,0,0,341.51,67.08Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.25,70.09l.13.34a.31.31,0,0,0,.58,0l.14-.34a3,3,0,0,0,.21-1.11V62.32H343V69A3,3,0,0,0,343.25,70.09Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.31,65.88V69a3,3,0,0,1-.21,1.11l-.14.34a.31.31,0,0,1-.58,0l-.13-.34A3,3,0,0,1,343,69v-3.1A3.87,3.87,0,0,1,344.31,65.88Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.89,70.54l0,0,0,0h0l-.06,0s.11,0,.14-.3.11-1,.11-1.3V65.84l.32,0V69a3,3,0,0,1-.21,1.11l-.14.34a.2.2,0,0,1,0,.08Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.51,70.49a1.09,1.09,0,0,0,.63.89l.25.12.05,0,.06,0a3.5,3.5,0,0,0,2.45,0h0l.25-.12a1.09,1.09,0,0,0,.63-.89,1.07,1.07,0,0,0-.63-.88,3.39,3.39,0,0,0-3.07,0A1.07,1.07,0,0,0,341.51,70.49Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.72,70.69V67.9l-.12-.78.94-.68a.91.91,0,0,1,.3.64v3.41a1.09,1.09,0,0,1-.63.89l-.25.12h0a3.47,3.47,0,0,1-1.28.22,3.68,3.68,0,0,1-1.17-.18l-.06,0-.05,0-.07,0C343.7,71.81,344.72,71.21,344.72,70.69Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.3,71.46l-.16-.08a1.72,1.72,0,0,1-.35-.28V66.75h.51Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.82,71.63l-.25-.07V67h.25Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.62,66c.81.24,1.22.69,1.22,1.13s-.41.89-1.22,1.13a3.37,3.37,0,0,1-1.89,0c-.82-.24-1.22-.69-1.22-1.13s.4-.89,1.22-1.13A3.37,3.37,0,0,1,344.62,66Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.62,66c.81.24,1.22.69,1.22,1.13s-.41.89-1.22,1.13a3.37,3.37,0,0,1-1.89,0c-.82-.24-1.22-.69-1.22-1.13s.4-.89,1.22-1.13A3.37,3.37,0,0,1,344.62,66Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,67.08v1.2a3.87,3.87,0,0,0,1.27,0V67.12a.36.36,0,0,1-.19.22,1,1,0,0,1-.9,0A.32.32,0,0,1,343,67.08Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.12,67.34a.36.36,0,0,0,.19-.22v1.16l-.32,0V67.4Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,65.89v1.19a.32.32,0,0,0,.18.26,1,1,0,0,0,.9,0,.36.36,0,0,0,.19-.22V65.88A3.61,3.61,0,0,0,343,65.89Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.29,69.29a3.21,3.21,0,0,1-.19.8l-.14.34a.31.31,0,0,1-.58,0l-.13-.34a3.24,3.24,0,0,1-.2-.8A3.69,3.69,0,0,1,344.29,69.29Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.42,70.66v-4.9A.73.73,0,0,0,345,65c-.75-.38-.85-.69-.85-1.07V62.67h.64v1.17a.61.61,0,0,0,.38.55,1.89,1.89,0,0,1,.35.17,1.28,1.28,0,0,1,.75,1v5a1.28,1.28,0,0,1-.75,1,4,4,0,0,1-2.67.35C344.91,72.19,345.42,71.3,345.42,70.66Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.86,64.56a2.16,2.16,0,0,1,.34-.17.59.59,0,0,0,.38-.55V62.67h.24v1.4a.67.67,0,0,1-.38.51c-.21.11-.86.4-1,.71a4.58,4.58,0,0,0-.1,1.57v3.56a1.63,1.63,0,0,0,1,1.5,3.15,3.15,0,0,1-.49-.22,1.26,1.26,0,0,1-.76-1.06v-5A1.27,1.27,0,0,1,341.86,64.56Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.31,65.88v1.24a.36.36,0,0,1-.19.22l-.13.06V65.84Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.5,70.46c0,.05.08.09.17.09s.18,0,.18-.09-.08-.09-.18-.09S343.5,70.41,343.5,70.46Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.61,70.15a2.44,2.44,0,0,1-.05-.69V62.32h.11v7.16A1.75,1.75,0,0,1,343.61,70.15Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.2,62.32h.23V70h0a2.29,2.29,0,0,1-.23-1Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.29,62.32v.34a.69.69,0,0,0,.4.57,2.18,2.18,0,0,0,2,0A1,1,0,0,0,345,63a.6.6,0,0,0,.1-.3v-.35s0-.06,0-.09a.76.76,0,0,0-.4-.48h0a2.17,2.17,0,0,0-1.94,0,.72.72,0,0,0-.39.47A.38.38,0,0,0,342.29,62.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.56,63.12v-.51c0-.2-.05-.51.3-.51a1,1,0,0,0,.77-.36h0a.76.76,0,0,1,.4.48s0,.06,0,.09v.35a.6.6,0,0,1-.1.3,1,1,0,0,1-.31.26,2.18,2.18,0,0,1-2,0C343.08,63.38,343.56,63.31,343.56,63.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.65,62.88a.6.6,0,0,0,0-1.13,2.18,2.18,0,0,0-2,0,.6.6,0,0,0,0,1.13A2.12,2.12,0,0,0,344.65,62.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.65,62.88a.6.6,0,0,0,0-1.13,2.18,2.18,0,0,0-2,0,.6.6,0,0,0,0,1.13A2.12,2.12,0,0,0,344.65,62.88Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.29,61.26v.87a.28.28,0,0,0,0,.09.73.73,0,0,0,.39.48,2,2,0,0,0,.87.23,2.06,2.06,0,0,0,1.09-.24.81.81,0,0,0,.31-.26.72.72,0,0,0,.09-.2s0-.07,0-.1v-.87a.7.7,0,0,0-.41-.57l-.07,0a2.19,2.19,0,0,0-1.89,0A.7.7,0,0,0,342.29,61.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.67,58.57a.75.75,0,0,1,.76.75v1.94h0a.4.4,0,0,1-.22.31,1.19,1.19,0,0,1-1.07,0,.38.38,0,0,1-.22-.31h0V59.32A.75.75,0,0,1,343.67,58.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.24,58.7h0a.78.78,0,0,1,.43-.13.75.75,0,0,1,.76.75v1.94h0a.4.4,0,0,1-.22.31,1.19,1.19,0,0,1-1.07,0,.43.43,0,0,1-.18-.17.67.67,0,0,0,.63.07c.31-.11.4-.41.4-.82V59.39C344,58.89,343.58,58.47,343.24,58.7Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.27,60.42h0a.2.2,0,0,0,.2-.2V59.15a.2.2,0,0,0-.2-.2h0a.2.2,0,0,0-.2.2v1.07A.2.2,0,0,0,343.27,60.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.07,60.85a.2.2,0,1,0,.2-.2A.2.2,0,0,0,343.07,60.85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,62.43a.81.81,0,0,1-.31.26,2.06,2.06,0,0,1-1.09.24v-.32c0-.2-.06-.44.3-.51a1.45,1.45,0,0,0,1-.51.71.71,0,0,0-.24-.94l.07,0a.7.7,0,0,1,.41.57v.87s0,.06,0,.1A.72.72,0,0,1,345,62.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.14,66.2a1.67,1.67,0,0,1,.23-.12c-1.19.62-.65,1.54.09,1.89a4.47,4.47,0,0,0,2.63.06,3.46,3.46,0,0,1-2.95-.06,1.09,1.09,0,0,1-.63-.89A1.07,1.07,0,0,1,342.14,66.2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-40",
    d: "M359.6,75.78c2.07,1.2,2.07,3.14,0,4.34a8.32,8.32,0,0,1-7.5,0c-2.08-1.2-2.08-3.14,0-4.34A8.32,8.32,0,0,1,359.6,75.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Jar--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.41,66.09a5,5,0,0,1,.66-.31,1.14,1.14,0,0,0,.72-1V63.48h4.12v1.26a1.14,1.14,0,0,0,.72,1,4.33,4.33,0,0,1,.65.31,2.43,2.43,0,0,1,1.43,2V77.6a2.43,2.43,0,0,1-1.43,2,7.63,7.63,0,0,1-6.87,0,2.44,2.44,0,0,1-1.42-2V68.08A2.44,2.44,0,0,1,352.41,66.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,79.42c1.73-1,1.73-2.6,0-3.59a7,7,0,0,0-6.29,0c-1.73,1-1.73,2.6,0,3.59A7,7,0,0,0,359,79.42Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.39,64.81a5.33,5.33,0,0,1,3.31-.53v-.8h1.21v1.26a1.14,1.14,0,0,0,.72,1,4.33,4.33,0,0,1,.65.31l0,0a2.39,2.39,0,0,1,1.4,2v9.52a2.43,2.43,0,0,1-1.43,2,7.6,7.6,0,0,1-5,.66c3.95.27,4.9-1.4,4.9-2.62V68.37a1.39,1.39,0,0,0-.36-1.08,2.29,2.29,0,0,1-.48.35,5.44,5.44,0,0,1-4.91,0C352,66.86,352,65.59,353.39,64.81Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.41,66.09a5,5,0,0,1,.66-.31,1.14,1.14,0,0,0,.72-1V63.48h.45v1.69a1.25,1.25,0,0,1-.73,1c-.38.21-1.62.75-1.92,1.33a8.84,8.84,0,0,0-.19,3v6.72A3,3,0,0,0,353.34,80a5.57,5.57,0,0,1-.93-.41,2.38,2.38,0,0,1-1.42-2V68.08A2.44,2.44,0,0,1,352.41,66.09Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.38,65.25v.36a1.7,1.7,0,0,0,1,1.42,5.44,5.44,0,0,0,4.91,0,2.28,2.28,0,0,0,.76-.66,1.3,1.3,0,0,0,.25-.75v-.38a.93.93,0,0,0,0-.23,1.89,1.89,0,0,0-1-1.18l-.05,0a5.4,5.4,0,0,0-4.86,0,1.89,1.89,0,0,0-1,1.18A1,1,0,0,0,352.38,65.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.56,67.24V66c0-.51-.13.18.76.18s1.45-1.78,1.93-2.35l.05,0a1.89,1.89,0,0,1,1,1.18.93.93,0,0,1,0,.23v.38a1.3,1.3,0,0,1-.25.75,2.28,2.28,0,0,1-.76.66,5.44,5.44,0,0,1-4.91,0C354.35,67.41,355.56,67.72,355.56,67.24Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.3,66.66c1.35-.78,1.35-2,0-2.83a5.38,5.38,0,0,0-4.91,0c-1.35.78-1.35,2,0,2.83A5.44,5.44,0,0,0,358.3,66.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.38,64.05v.71a1,1,0,0,0,0,.25,1.89,1.89,0,0,0,1,1.18,4.92,4.92,0,0,0,2.17.58,5.24,5.24,0,0,0,2.74-.58,2.4,2.4,0,0,0,.76-.66,1.41,1.41,0,0,0,.23-.52,1,1,0,0,0,0-.24V64a1.72,1.72,0,0,0-1-1.42l-.19-.09a5.46,5.46,0,0,0-4.72.09A1.71,1.71,0,0,0,352.38,64.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.3,65.44c1.35-.78,1.35-2,0-2.83a5.44,5.44,0,0,0-4.91,0c-1.35.78-1.35,2,0,2.83A5.44,5.44,0,0,0,358.3,65.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.06,65.53a2.4,2.4,0,0,1-.76.66,5.24,5.24,0,0,1-2.74.58h0c0-.26-.15-.45.76-.62a3.6,3.6,0,0,0,2.39-1.29,1.74,1.74,0,0,0-.6-2.33l.19.09a1.72,1.72,0,0,1,1,1.42v.73a1,1,0,0,1,0,.24A1.41,1.41,0,0,1,359.06,65.53Z",
    style: {
      opacity: 0.05
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M365.87,83.39a4.66,4.66,0,0,1-4.21,0,1.28,1.28,0,0,1,0-2.43,4.66,4.66,0,0,1,4.21,0A1.28,1.28,0,0,1,365.87,83.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.24,71.71V81.83a1.21,1.21,0,0,1-.72,1,3.86,3.86,0,0,1-3.5,0,1.23,1.23,0,0,1-.73-1V71.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.36,83.21a3.23,3.23,0,0,0,1.16-.37,1.21,1.21,0,0,0,.72-1V71.71h-1.88Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.52,72.72a3.86,3.86,0,0,1-3.5,0,1.06,1.06,0,0,1,0-2,3.86,3.86,0,0,1,3.5,0A1.07,1.07,0,0,1,365.52,72.72Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.56,69.74v1.77a.89.89,0,0,1-.52.73,2.78,2.78,0,0,1-2.54,0,.9.9,0,0,1-.53-.73V69.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.2,72.51a2.24,2.24,0,0,0,.84-.27.89.89,0,0,0,.52-.73V69.74H364.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,70.48a2.84,2.84,0,0,1-2.54,0,.78.78,0,0,1,0-1.47A2.84,2.84,0,0,1,365,69,.78.78,0,0,1,365,70.48Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.14,68.79v.77a.67.67,0,0,1-.4.56,2.14,2.14,0,0,1-1.94,0,.69.69,0,0,1-.41-.56v-.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.1,70.33a1.86,1.86,0,0,0,.64-.21.67.67,0,0,0,.4-.56v-.77h-1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.74,69.35a2.14,2.14,0,0,1-1.94,0,.59.59,0,0,1,0-1.12,2.14,2.14,0,0,1,1.94,0A.59.59,0,0,1,364.74,69.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.69,66.92v1.8a.48.48,0,0,1-.27.38,1.51,1.51,0,0,1-1.31,0,.48.48,0,0,1-.27-.38v-1.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.2,69.19l.22-.09a.48.48,0,0,0,.27-.38v-1.8h-.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.42,67.3a1.44,1.44,0,0,1-1.31,0,.4.4,0,0,1,0-.76,1.44,1.44,0,0,1,1.31,0A.4.4,0,0,1,364.42,67.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.31,68a.44.44,0,0,0-.2-.34c-.11-.07-.2,0-.2.11a.44.44,0,0,0,.2.35C363.22,68.15,363.31,68.1,363.31,68Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.56,66.72A.89.89,0,0,0,365,66a2.84,2.84,0,0,0-2.54,0,.9.9,0,0,0-.53.73v3a.91.91,0,0,0,.53.74,2.84,2.84,0,0,0,2.54,0,.9.9,0,0,0,.52-.73h0v-3Z",
    style: {
      fill: "#fafafa",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,67.46a2.84,2.84,0,0,1-2.54,0,.78.78,0,0,1,0-1.47A2.84,2.84,0,0,1,365,66,.78.78,0,0,1,365,67.46Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.46,87a5.3,5.3,0,0,1-4.81,0c-1.33-.77-1.33-2,0-2.78a5.36,5.36,0,0,1,4.81,0C373.78,85,373.78,86.22,372.46,87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,85.22V73.47a3,3,0,1,0-5.91,0V85.22a1.48,1.48,0,0,0,.86,1.21,4.68,4.68,0,0,0,4.19,0A1.5,1.5,0,0,0,373,85.22Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.89,76.65v8.07c0,1.5-2.65,2.21-4.37,1.38a2.2,2.2,0,0,0,.44.33,4.68,4.68,0,0,0,4.19,0,1.5,1.5,0,0,0,.86-1.21V73.47a3,3,0,0,0-3-3v.84C371.62,72.49,371.89,73,371.89,76.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.47,68.31v2.85a.71.71,0,0,1-.42.58,2.25,2.25,0,0,1-2,0,.71.71,0,0,1-.42-.58V68.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 370.05,
    cy: 68.31,
    rx: 1.41,
    ry: 0.82,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.62,68.72a1,1,0,0,0-.82,0,1.11,1.11,0,0,0,.26.2,1.85,1.85,0,0,0,.72.23C369.86,69,369.81,68.82,369.62,68.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.15,76.65a4.68,4.68,0,0,1-4.19,0,1.48,1.48,0,0,1-.86-1.21v5.62a1.45,1.45,0,0,0,.86,1.2,4.62,4.62,0,0,0,4.19,0,1.47,1.47,0,0,0,.86-1.2V75.44A1.48,1.48,0,0,1,372.15,76.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.15,76.65l-.26.11v5.62a2.06,2.06,0,0,0,.26-.12,1.47,1.47,0,0,0,.86-1.2V75.44A1.48,1.48,0,0,1,372.15,76.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.65,50.77V49h0a.6.6,0,0,1,.35-.46l10.45-6a1.82,1.82,0,0,1,1.61,0l30,17.35a.6.6,0,0,1,.35.46h0v1.74h0a.6.6,0,0,1-.35.47l-10.45,6a1.76,1.76,0,0,1-1.61,0L337,51.23a.59.59,0,0,1-.35-.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.1,60.81l-10.45,6a1.76,1.76,0,0,1-1.61,0L337,49.49a.49.49,0,0,1,0-.92l10.45-6a1.82,1.82,0,0,1,1.61,0l30,17.35A.49.49,0,0,1,379.1,60.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.85,67v1.74a1.6,1.6,0,0,0,.8-.19l10.45-6a.6.6,0,0,0,.35-.47h0V60.34h0a.49.49,0,0,0-.07-.19c.12.22,0,.48-.28.66l-10.45,6A1.6,1.6,0,0,1,367.85,67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.19,50.55a7.67,7.67,0,0,1-6.92,0c-1.91-1.11-1.91-2.9,0-4a7.61,7.61,0,0,1,6.92,0C351.1,47.65,351.1,49.44,349.19,50.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.11,48.52h0V40.27h8.27v8.25h0a2,2,0,0,1-1.2,1.76,6.48,6.48,0,0,1-5.85,0A2,2,0,0,1,341.11,48.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.16,42a6.48,6.48,0,0,1-5.85,0c-1.61-.93-1.61-2.44,0-3.37a6.48,6.48,0,0,1,5.85,0C349.77,39.51,349.77,41,348.16,42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,41.82a6.23,6.23,0,0,1-5.49,0c-1.51-.86-1.51-2.25,0-3.1a6.16,6.16,0,0,1,5.49,0C349.5,39.57,349.5,41,348,41.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.49,39.12a6.16,6.16,0,0,1,5.49,0,2,2,0,0,1,1.12,1.35A2,2,0,0,1,348,41.82a6.23,6.23,0,0,1-5.49,0,2.06,2.06,0,0,1-1.12-1.35A2,2,0,0,1,342.49,39.12Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.37,47.12a2,2,0,0,1-1.21,1.7,6.42,6.42,0,0,1-5.85,0,2.05,2.05,0,0,1-1.21-1.68V41.61a2.08,2.08,0,0,0,1.21,1.69,6.48,6.48,0,0,0,5.85,0,2,2,0,0,0,1.21-1.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.24,46.62c.15-.38.58-.78.85-.63a3.85,3.85,0,0,1,.84,1.6c.15.55.11,1.06-.23.94s-.44-.62-.61-.72-.28.28-.61,0A1.1,1.1,0,0,1,342.24,46.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.23,45a1,1,0,0,0,.26.83c.17.13.33,0,.35-.36a1,1,0,0,0-.26-.83C343.41,44.47,343.25,44.63,343.23,45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,46.41a.92.92,0,0,0,.21.76c.15.13.31,0,.34-.28a.92.92,0,0,0-.21-.76C344.15,46,344,46.12,344,46.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,44.8c0,.36-.09.59-.26.53s-.33-.42-.36-.77.09-.6.26-.53A1,1,0,0,1,343,44.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.22,45.4c0,.33-.06.57-.22.52s-.3-.35-.34-.68.06-.56.21-.52S342.18,45.07,342.22,45.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.54,50.77a6.56,6.56,0,0,0,4.62-.49,2,2,0,0,0,1.21-1.76h0V40.27A2,2,0,0,1,348.16,42a2.14,2.14,0,0,1-.4.2v7.37C347.76,50.21,345.46,51,343.54,50.77Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.29,41.74l.44-.26c.36-.2.45-.48.22-.62a1.26,1.26,0,0,0-1.08.13l-.44.25c-.36.2-.45.48-.21.62A1.24,1.24,0,0,0,344.29,41.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 344.52,
    cy: 41.11,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.88,41.72a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28.55.55,0,0,1,.47,0A.15.15,0,0,1,343.88,41.72Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.4,54.79a5.81,5.81,0,0,1-5.29,0c-1.46-.84-1.46-2.21,0-3a5.87,5.87,0,0,1,5.29,0C357.86,52.58,357.86,54,356.4,54.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,47a1.76,1.76,0,0,1,1-1.44,5.53,5.53,0,0,1,5,0,1.76,1.76,0,0,1,1,1.44h0v6h0a1.76,1.76,0,0,1-1,1.44,5.53,5.53,0,0,1-5,0A1.76,1.76,0,0,1,350,53h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.38,45.44v9.2l-.32-.16a2.58,2.58,0,0,1-.56-.43V46a2.58,2.58,0,0,1,.56-.43Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.3,54.94a4.1,4.1,0,0,1-.5-.14V45.28a4.1,4.1,0,0,1,.5-.14Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.08,46.67a2.6,2.6,0,0,1,.83-.72,5.94,5.94,0,0,1,5-.16v-.27l.16.08a1.76,1.76,0,0,1,1,1.44v1.38h0v2.64h0v2a1.76,1.76,0,0,1-1,1.44,5.53,5.53,0,0,1-5,0,2.75,2.75,0,0,1-.63-.49,4.65,4.65,0,0,0,3.5.71c1.21-.24,1.95-1,1.95-1.57V52.6a5.24,5.24,0,0,1-2.44.54V50.46a5.36,5.36,0,0,0,2.44-.5v-.79a5.91,5.91,0,0,1-5-.16,2.38,2.38,0,0,1-.89-.82V47A1.19,1.19,0,0,1,350.08,46.67Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.48,53.29V45.91a1.51,1.51,0,0,1,.6,1.13v6a1.76,1.76,0,0,1-1,1.44,4.63,4.63,0,0,1-1.34.48C356,54.6,356.48,53.7,356.48,53.29Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.81,45.43a1.84,1.84,0,0,1,1.1-1.52,5.79,5.79,0,0,1,5.28,0,1.84,1.84,0,0,1,1.1,1.52h0v1.66h0a1.85,1.85,0,0,1-1.1,1.53,5.85,5.85,0,0,1-5.28,0,1.85,1.85,0,0,1-1.1-1.53h0V45.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M352.25,47h.18v2.19l-.18,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M353.08,49.22V47.05h.18v2.18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M350.13,48V46h.18v2.17Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M349.9,47.54a1.2,1.2,0,0,1-.09-.45V45.43a.8.8,0,0,1,0-.15h.06Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M350.94,48.63h0l-.15-.11V46.45h.18Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M351.47,46.75h.18v2.19a1.27,1.27,0,0,1-.18-.06Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M355.51,48.92v-2.2h.18v2.13Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M356.94,48a1.12,1.12,0,0,1-.18.2V45.9h.18Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M357.29,45.43v1.66h0a1.2,1.2,0,0,1-.09.45V45.13h0a1.57,1.57,0,0,1,.05.3Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M356.39,48.48c-.06,0-.11.09-.18.13V46.37h.18Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M353.92,47.05h.18v2.17h-.18Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M354.74,46.94h.18V49.1l-.18,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M352.66,49.18c1.85,0,2.82-.59,3.12-1.08a3.91,3.91,0,0,0,.26-1.74s.21-1.56.17-1.56l.81-.18a1.43,1.43,0,0,1,.27.81h0v1.66h0a1.85,1.85,0,0,1-1.1,1.53A5.73,5.73,0,0,1,352.66,49.18Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.19,47a5.85,5.85,0,0,1-5.28,0c-1.47-.84-1.47-2.21,0-3.05a5.79,5.79,0,0,1,5.28,0C357.66,44.75,357.66,46.12,356.19,47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.7,46.83c-1.25-.85-1.18-2.12.21-2.92a5.38,5.38,0,0,1,2.57-.64,4.13,4.13,0,0,1,1.36.47,1.56,1.56,0,0,1,0,2.88A5.13,5.13,0,0,1,350.7,46.83Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.84,54.32a5.79,5.79,0,0,1-4.58,0c-1.27-.64-1.27-1.67,0-2.3a5.7,5.7,0,0,1,4.58,0C357.11,52.65,357.11,53.68,355.84,54.32Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.08,48.6A1.76,1.76,0,0,1,356,50a5.15,5.15,0,0,1-2.49.59v2.64a5,5,0,0,0,2.49-.59,1.76,1.76,0,0,0,1-1.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,46.26a4.94,4.94,0,0,1-3.56,1.16c-2.35-.06-3.29-1.35-3.42-1.74a1.5,1.5,0,0,1,.32-1.36,1.58,1.58,0,0,0-.53,1.11v1.66c0,.14-.07.62.69,1.25a1.85,1.85,0,0,1-.45-1V46.2s.83,1.39,3.39,1.39S356.88,46.47,357,46.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.54,58.4a5.81,5.81,0,0,1-5.29,0c-1.46-.84-1.46-2.21,0-3a5.87,5.87,0,0,1,5.29,0C365,56.19,365,57.56,363.54,58.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.16,50.65a1.74,1.74,0,0,1,1-1.43,5.47,5.47,0,0,1,5,0,1.74,1.74,0,0,1,1,1.43h0v6h0a1.76,1.76,0,0,1-1,1.44,5.53,5.53,0,0,1-5,0,1.76,1.76,0,0,1-1-1.44h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.52,49.05v9.2l-.32-.16a2.3,2.3,0,0,1-.56-.43v-8a2.56,2.56,0,0,1,.56-.42Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.44,58.55a2.85,2.85,0,0,1-.5-.14V48.89l.5-.14Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.23,50.28a2.43,2.43,0,0,1,.82-.71,5.91,5.91,0,0,1,5-.17v-.27a1.29,1.29,0,0,1,.16.09,1.74,1.74,0,0,1,1,1.43V52h0v2.65h0v2a1.76,1.76,0,0,1-1,1.44,5.53,5.53,0,0,1-5,0,2.75,2.75,0,0,1-.63-.49,4.66,4.66,0,0,0,3.5.71c1.21-.24,1.95-1,1.95-1.56v-.54a5.25,5.25,0,0,1-2.44.55V54.07a5.36,5.36,0,0,0,2.44-.5v-.79a5.87,5.87,0,0,1-5-.16,2.54,2.54,0,0,1-.89-.81V50.65A1.21,1.21,0,0,1,357.23,50.28Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.62,56.9V49.52a1.51,1.51,0,0,1,.6,1.13v6a1.76,1.76,0,0,1-1,1.44,4.39,4.39,0,0,1-1.33.48C363.17,58.21,363.62,57.31,363.62,56.9Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,49a1.86,1.86,0,0,1,1.1-1.52,5.81,5.81,0,0,1,5.29,0A1.84,1.84,0,0,1,364.43,49h0V50.7h0a1.84,1.84,0,0,1-1.09,1.53,5.87,5.87,0,0,1-5.29,0A1.86,1.86,0,0,1,357,50.7h0V49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M359.39,50.56h.18v2.19a1.13,1.13,0,0,1-.18,0Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M360.22,52.84V50.66h.18v2.19Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M357.27,51.57v-2h.18v2.18Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M357,51.16a1.5,1.5,0,0,1-.09-.46V49a.8.8,0,0,1,0-.15H357Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M358.08,52.24h0a.83.83,0,0,1-.15-.11v-2h.18Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M358.61,50.36h.18v2.19l-.18,0Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M362.65,52.53v-2.2h.18v2.14Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M364.09,51.59l-.18.2V49.51h.18Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M364.43,49V50.7h0a1.25,1.25,0,0,1-.09.46V48.74h0a1,1,0,0,1,.05.3Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M363.53,52.09c-.06,0-.11.09-.18.13V50h.18Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M361.06,50.66h.18v2.17h-.18Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M361.89,50.55h.17v2.16l-.17,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M359.8,52.8c1.85,0,2.82-.59,3.12-1.08a3.85,3.85,0,0,0,.26-1.75s.21-1.55.17-1.56l.81-.18a1.43,1.43,0,0,1,.27.81h0V50.7h0a1.84,1.84,0,0,1-1.09,1.53A5.83,5.83,0,0,1,359.8,52.8Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.34,50.57a5.87,5.87,0,0,1-5.29,0c-1.46-.84-1.46-2.21,0-3a5.81,5.81,0,0,1,5.29,0C364.8,48.36,364.8,49.73,363.34,50.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.85,50.44c-1.26-.85-1.19-2.12.2-2.92a5.37,5.37,0,0,1,2.57-.63,4.12,4.12,0,0,1,1.36.46,1.57,1.57,0,0,1,0,2.89A5.15,5.15,0,0,1,357.85,50.44Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,57.93a5.79,5.79,0,0,1-4.58,0c-1.26-.64-1.26-1.67,0-2.3a5.7,5.7,0,0,1,4.58,0C364.25,56.26,364.25,57.29,363,57.93Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.22,52.21a1.76,1.76,0,0,1-1,1.44,5.15,5.15,0,0,1-2.49.59v2.65a5,5,0,0,0,2.49-.6,1.76,1.76,0,0,0,1-1.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.15,49.87A5,5,0,0,1,360.58,51c-2.35-.06-3.29-1.34-3.42-1.74a1.5,1.5,0,0,1,.32-1.36A1.58,1.58,0,0,0,357,49V50.7c0,.14-.07.62.69,1.25a1.85,1.85,0,0,1-.45-1V49.81s.83,1.39,3.39,1.39S364,50.08,364.15,49.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-40",
    d: "M373.51,59.06c2.07,1.2,2.07,3.14,0,4.33a8.28,8.28,0,0,1-7.51,0c-2.07-1.19-2.07-3.13,0-4.33A8.28,8.28,0,0,1,373.51,59.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--jar--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.32,49.37a5,5,0,0,1,.66-.32,1.12,1.12,0,0,0,.71-1V46.75h4.13V48a1.1,1.1,0,0,0,.71,1,5,5,0,0,1,.66.32,2.4,2.4,0,0,1,1.42,2v9.52a2.39,2.39,0,0,1-1.42,2,7.56,7.56,0,0,1-6.87,0,2.39,2.39,0,0,1-1.42-2V51.35A2.4,2.4,0,0,1,366.32,49.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.89,62.7c1.74-1,1.74-2.6,0-3.6a7,7,0,0,0-6.28,0c-1.74,1-1.74,2.61,0,3.6A7,7,0,0,0,372.89,62.7Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.3,48.08a5.36,5.36,0,0,1,3.3-.52v-.81h1.22V48a1.1,1.1,0,0,0,.71,1,5,5,0,0,1,.66.32h0a2.4,2.4,0,0,1,1.4,2v9.52a2.39,2.39,0,0,1-1.42,2,7.63,7.63,0,0,1-5.05.67c3.95.27,4.91-1.41,4.91-2.62V51.64a1.37,1.37,0,0,0-.37-1.07,2.27,2.27,0,0,1-.48.34,5.36,5.36,0,0,1-4.9,0C365.94,50.13,365.94,48.86,367.3,48.08Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.32,49.37a5,5,0,0,1,.66-.32,1.12,1.12,0,0,0,.71-1V46.75h.45v1.69a1.26,1.26,0,0,1-.72,1c-.39.21-1.62.74-1.92,1.33a8.82,8.82,0,0,0-.19,3v6.72a3,3,0,0,0,1.94,2.83,5.26,5.26,0,0,1-.93-.42,2.36,2.36,0,0,1-1.42-2V51.35A2.4,2.4,0,0,1,366.32,49.37Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.28,48.53v.36a1.74,1.74,0,0,0,1,1.42,5.44,5.44,0,0,0,4.91,0,2.4,2.4,0,0,0,.76-.67,1.27,1.27,0,0,0,.25-.75v-.37a.85.85,0,0,0,0-.23,1.83,1.83,0,0,0-1-1.19l0,0a5.46,5.46,0,0,0-4.86,0,1.86,1.86,0,0,0-1,1.18A1,1,0,0,0,366.28,48.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.47,50.52V49.24c0-.5-.13.18.76.18s1.45-1.77,1.93-2.35l0,0a1.83,1.83,0,0,1,1,1.19.85.85,0,0,1,0,.23v.37a1.27,1.27,0,0,1-.25.75,2.4,2.4,0,0,1-.76.67,5.44,5.44,0,0,1-4.91,0C368.26,50.68,369.47,51,369.47,50.52Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.2,49.93c1.36-.78,1.36-2,0-2.83a5.42,5.42,0,0,0-4.9,0c-1.36.78-1.36,2,0,2.83A5.36,5.36,0,0,0,372.2,49.93Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.28,47.32V48a1,1,0,0,0,0,.24,1.87,1.87,0,0,0,1,1.19,4.79,4.79,0,0,0,2.17.57,5.07,5.07,0,0,0,2.74-.58,2.5,2.5,0,0,0,.76-.66,1.34,1.34,0,0,0,.22-.51,1,1,0,0,0,0-.24v-.73a1.72,1.72,0,0,0-1-1.42l-.19-.1a5.46,5.46,0,0,0-4.72.1A1.73,1.73,0,0,0,366.28,47.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.2,48.72c1.36-.79,1.36-2,0-2.84a5.42,5.42,0,0,0-4.9,0c-1.36.79-1.36,2,0,2.84A5.42,5.42,0,0,0,372.2,48.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,48.8a2.5,2.5,0,0,1-.76.66,5.07,5.07,0,0,1-2.74.58h0c0-.25-.15-.44.76-.62a3.61,3.61,0,0,0,2.39-1.28,1.76,1.76,0,0,0-.6-2.34l.19.1a1.72,1.72,0,0,1,1,1.42v.73a1,1,0,0,1,0,.24A1.34,1.34,0,0,1,373,48.8Z",
    style: {
      opacity: 0.05
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-3--inject-40"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "479.01 150.69 477.25 151.7 396.62 105.15 398.38 104.14 479.01 150.69",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.38 104.14 477.25 149.68 477.25 99.39 398.38 53.85 398.38 104.14",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.55,140.21c0,1.63-1.15,2.3-2.56,1.48L447.26,128a5.66,5.66,0,0,1-2.56-4.44V79.32L473.55,96Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.53,112.15c1.18,2.59,3.45,3.24,4.28,4.16s.76,2.37.67,4.47,1.66,4.64,2.83,3.76a4.59,4.59,0,0,0,.41-.36c.55-.55,1.48.06,2,1.3.15.38.32.78.51,1.19.93,2,2.48,2.31,3.12.75s-.68-4.29.86-4,3.49,1.25,4.87,0c1-.87,1.2-3-.17-8.7s-3.54-6.38-5.21-5.76-3.59,3.06-4.93,2.14c-2.12-1.41-3.67-6.81-5.87-9.85s-3.73-1.6-4.07.34S448.34,109.55,449.53,112.15Zm13.55,2.7c.13-.41.26-.8.39-1.2a2.78,2.78,0,0,1,.33-.78,1.24,1.24,0,0,1,.81-.44,1.35,1.35,0,0,1,1.22.32,1.76,1.76,0,0,1,.31.38,7.57,7.57,0,0,1,.75,1.82c.42,1.56,1.09,5,.08,5.45a1.16,1.16,0,0,1-.82,0,3.46,3.46,0,0,1-1.88-1.24,10.34,10.34,0,0,1-.78-1.28,5,5,0,0,1-.6-1.61A3.08,3.08,0,0,1,463.08,114.85Zm-2.65,7.09c.27-.15.47.17.69.6s.59,1,.91,1.53a2.1,2.1,0,0,1,.32.77.73.73,0,0,1-.13.58.66.66,0,0,1-.36.22.88.88,0,0,1-.43,0,1.53,1.53,0,0,1-.78-.82C460.21,124,459.84,122.25,460.43,121.94Zm-4.72-1.88c.41-.18,1.17-.83,1.5.49a2.61,2.61,0,0,1,0,1.11,3,3,0,0,1-.21.77c-.1.25-.24.48-.46.48s-.58-.36-.85-.71C455.14,121.48,455.26,120.26,455.71,120.06Zm-5.6-14.78a1.34,1.34,0,0,1,.82-.92,3.11,3.11,0,0,1,.53-.22.94.94,0,0,1,.89.17,3.22,3.22,0,0,1,.88,1.21c.28.6.46,1.26.71,1.88a4.76,4.76,0,0,1,.42,1.57,2.2,2.2,0,0,1-1.08,1.71,2.78,2.78,0,0,1-1.67.52,1,1,0,0,1-.79-.55,3.57,3.57,0,0,1-.35-1.09,22,22,0,0,1-.41-3.25A3.79,3.79,0,0,1,450.11,105.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.61,125.83c.78-.45.95.16,2.07.29s1.38-.71,2.28-.57,1.85,3,.67,3.59-1.54.58-1.56,1.64.15,7.26.15,7.26L465,136.21s0-5.71,0-6.44a9.19,9.19,0,0,0-.49-2.18C464.42,127,464.21,126.07,464.61,125.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.49,118.66c-.77-1.35-.69-.66-2-1.61-.77-.55-.82-1.36-1.72-2.25s-2.37.57-1.19,2.54a8.11,8.11,0,0,1,1.47,4.22c0,1.08-.14,5.91-.14,5.91l3.18,1.83s0-5.72,0-6.46a7,7,0,0,1,.3-2.2A2.44,2.44,0,0,0,453.49,118.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.13,105.79c1.63.94,2.55.72,2.77,1.27s.08,1-.17,1.12c-.57.35-1.87-.12-2.59-.43A5.41,5.41,0,0,1,457,106a1.92,1.92,0,0,1-.16-1.8C457.33,104.21,457.61,104.91,459.13,105.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.13,102.11c1.63,1,2.55.73,2.77,1.27s.08,1-.17,1.12c-.57.35-1.87-.12-2.59-.43a5.41,5.41,0,0,1-2.1-1.75,1.92,1.92,0,0,1-.16-1.8C457.33,100.53,457.61,101.23,459.13,102.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.13,98.43c1.63.95,2.55.73,2.77,1.27s.08,1-.17,1.12c-.57.35-1.87-.11-2.59-.43a5.48,5.48,0,0,1-2.1-1.74,1.94,1.94,0,0,1-.16-1.81C457.33,96.85,457.61,97.55,459.13,98.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.63,99.85l-5.43-3.16c-.28-.16-.51,0-.51.3v2.92a1.13,1.13,0,0,0,.51.89l5.43,3.15c.29.16.52,0,.52-.29v-2.93A1.11,1.11,0,0,0,470.63,99.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.43,118.79c0,1.63-1.14,2.3-2.56,1.48l-23.72-13.7a5.66,5.66,0,0,1-2.57-4.44V57.9l28.85,16.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.82,96.71s.3.3.13-.85-.29-2-.42-2.65c.14.26,2.67,4.52,3.09,4.71.23.1-.33-2.17-.32-2.36,1.68,3.5,3.2,6.51,3.71,7.38,1.13,1.92,3,2.36,3.39,4.19s-1.47,1-2.41,1.12-.86,2.6-1.92,2.46c-3.18-.43-1.31-2.7-2-5.72A76.45,76.45,0,0,0,422.82,96.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.58,76.44c.8-1.48-.85-4.52-.2-5.9s3.47-1.22,3.72,2.71,0,5.21,1.84,10.23c.87,2.41,2.73,6.55,4.56,10.41,0,.38,0,.76,0,1.14,0,0-.92-1.69-1.23-2.16-.59-.89-1.7-3.23-2.39-4.05-.17-.2,1.21,5.31,1.25,5.85,0,.36-.18,0-.32-.28-2.11-4.94-4.31-9.91-4.77-11-.87-2.08-2.78-2.72-3.34-3.8C412.85,77.9,414.05,77.43,414.58,76.44Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.52,78.42l-5.44-3.15c-.28-.16-.51,0-.51.3v2.92a1.15,1.15,0,0,0,.51.89l5.44,3.15c.28.16.51,0,.51-.3V79.31A1.15,1.15,0,0,0,433.52,78.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.87,106.16,479,154.74V98.38L394.87,49.8Zm1.75-53.32,80.63,46.55V151.7l-80.63-46.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.62 105.15 398.38 104.14 398.38 53.85 396.62 52.84 396.62 105.15",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.87 49.8 396.62 48.78 480.76 97.36 479.01 98.38 394.87 49.8",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.76 97.36 479.01 98.38 479.01 154.74 480.76 153.73 480.76 97.36",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.76 94.59 477.26 96.61 393.12 48.03 396.62 46.01 480.76 94.59",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.26 96.61 477.26 102.17 393.12 53.59 393.12 48.03 477.26 96.61",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.76 94.59 477.26 96.61 477.26 102.17 480.76 100.14 480.76 94.59",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.4,309a2.73,2.73,0,0,0,.82,2.89c1.36.92,5.26,2.31,10.21,1.36s7.56-2.55,9.44-4.22,4.54-4,6.77-4.64a14.61,14.61,0,0,0,4.91-2.25c.63-.64.34-3.26.34-3.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.17,288.86a.79.79,0,0,1,.8.56c.21.72.53,2.81.94,4a19.62,19.62,0,0,1,1,6.35c-.18,1.37-3.54,2.55-5.67,3.47a28.43,28.43,0,0,0-6.79,4.59,21.33,21.33,0,0,1-10.28,4.34c-3.85.25-8.27-.57-9.38-2.13-1.38-1.92-2.44-4.2,3.09-7,1.05-.53,4.7-2.85,5.94-3.69,3.36-2.26,5.69-4.28,7-8a2,2,0,0,1,.74-1.14,2,2,0,0,1,1.11-.18,42.52,42.52,0,0,1,5.68.57c.79.28,1.91.59,2,1.49a2.91,2.91,0,0,1-.15.92c-.06.19-.09.44.09.53s.38,0,.52-.17a12.92,12.92,0,0,0,1.42-1.8,5.16,5.16,0,0,1,.85-.9A10.92,10.92,0,0,0,399,290C399.3,289.67,399.18,289.28,399.17,288.86Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.17,288.86a.79.79,0,0,1,.8.56c.21.72.53,2.81.94,4a19.62,19.62,0,0,1,1,6.35c-.18,1.37-3.54,2.55-5.67,3.47a28.43,28.43,0,0,0-6.79,4.59,21.33,21.33,0,0,1-10.28,4.34c-3.85.25-8.27-.57-9.38-2.13-1.38-1.92-2.44-4.2,3.09-7,1.05-.53,4.7-2.85,5.94-3.69,3.36-2.26,5.69-4.28,7-8a2,2,0,0,1,.74-1.14,2,2,0,0,1,1.11-.18,42.52,42.52,0,0,1,5.68.57c.79.28,1.91.59,2,1.49a2.91,2.91,0,0,1-.15.92c-.06.19-.09.44.09.53s.38,0,.52-.17a12.92,12.92,0,0,0,1.42-1.8,5.16,5.16,0,0,1,.85-.9A10.92,10.92,0,0,0,399,290C399.3,289.67,399.18,289.28,399.17,288.86Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.41,307.81c.95-.82,1.95-1.62,3-2.35h0s-6.45,4.21-9.29,2.71c-1.83-1-1.09-2.34-1.08-2.77s-6.38-3-8.09-3h0c-.45.27-.84.49-1.08.61-5.53,2.83-4.47,5.11-3.09,7,1.11,1.56,4.34,2.6,9.32,2.24A21.77,21.77,0,0,0,389.41,307.81Z",
    style: {
      fill: "#845EC2",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.41,307.81c.95-.82,1.95-1.62,3-2.35h0s-6.45,4.21-9.29,2.71c-1.83-1-1.09-2.34-1.08-2.77s-6.38-3-8.09-3h0c-.45.27-.84.49-1.08.61-5.53,2.83-4.47,5.11-3.09,7,1.11,1.56,4.34,2.6,9.32,2.24A21.77,21.77,0,0,0,389.41,307.81Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.39,304.14c-3.46,1.55-1.9,2-.89,2.1s6.75-3.56,10.2-6.45c3.61-3,5.79-6.19,7.13-7.3.5-.41,1-.92,1.51-1.38-.15-.71-.27-1.35-.37-1.69a.79.79,0,0,0-.8-.56c0,.42.13.81-.2,1.15a10.92,10.92,0,0,1-.93.65,5.16,5.16,0,0,0-.85.9,12.92,12.92,0,0,1-1.42,1.8C392.93,297.17,385.85,302.58,382.39,304.14Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.72,305.75a.43.43,0,0,0,.21-.09.31.31,0,0,0,0-.46c-1.08-1-6-3.35-8.62-2.9a.33.33,0,0,0-.29.37.34.34,0,0,0,.41.26c2.42-.42,7.13,1.89,8,2.72A.43.43,0,0,0,381.72,305.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.69,303.78a.32.32,0,0,0,.21-.08.31.31,0,0,0,0-.46c-1.08-1-6-3.35-8.62-2.91a.33.33,0,0,0-.28.38.35.35,0,0,0,.4.26c2.43-.42,7.13,1.89,8,2.72A.35.35,0,0,0,384.69,303.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.67,301.91a.32.32,0,0,0,.21-.08.31.31,0,0,0,0-.46c-1.08-1.05-6-3.36-8.62-2.91a.33.33,0,0,0-.28.38.34.34,0,0,0,.4.26c2.43-.42,7.13,1.89,8,2.72A.35.35,0,0,0,387.67,301.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.4,299.83a.43.43,0,0,0,.22-.09.31.31,0,0,0,0-.46c-1.09-1-6-3.35-8.62-2.9a.33.33,0,0,0-.29.37.34.34,0,0,0,.41.26c2.42-.41,7.12,1.89,8,2.72A.42.42,0,0,0,390.4,299.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.08,297.74a.32.32,0,0,0,.21-.08.31.31,0,0,0,0-.46c-1.5-1.48-6.63-3.34-9.22-2.89a.33.33,0,0,0-.29.37.34.34,0,0,0,.41.26c2.33-.4,7.25,1.38,8.58,2.7A.33.33,0,0,0,393.08,297.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.71,315.13c.53,3,1.34,4.88,2.9,6.44s4.21,1.73,6.78.82,5.8-2.81,6.29-5.52a13.08,13.08,0,0,0-.73-7.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.93,291.73c1.08-.09,1.82,3.9,2.86,7.86,1.12,4.24,3,5.79,3.93,9.26,1.1,4,1,5.82-.57,8.56s-7.82,6.12-11.38,3.08c-2.91-2.48-3.34-5.65-3.52-9.74a79.11,79.11,0,0,0-.82-10.38c-.52-3-1.1-5.92-.19-6.4.12.43.25,1,.37,1.42s.37,2,1,1.88a5,5,0,0,0-.11-1.15,1.18,1.18,0,0,1,.2-1,2.38,2.38,0,0,1,1.16-.6c1-.33,2.1-.63,3.18-.87.53-.12,1.07-.22,1.61-.3a5.91,5.91,0,0,1,1.39-.06.92.92,0,0,1,.63.33,1,1,0,0,1,.1.46,2.58,2.58,0,0,0,.23.81c0,.11.17.24.32.19a.25.25,0,0,0,.15-.27c0-.49-.16-.84-.25-1.4,0-.26-.13-.62-.16-.88S437,292,436.93,291.73Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.93,291.73c1.08-.09,1.82,3.9,2.86,7.86,1.12,4.24,3,5.79,3.93,9.26,1.1,4,1,5.82-.57,8.56s-7.82,6.12-11.38,3.08c-2.91-2.48-3.34-5.65-3.52-9.74a79.11,79.11,0,0,0-.82-10.38c-.52-3-1.1-5.92-.19-6.4.12.43.25,1,.37,1.42s.37,2,1,1.88a5,5,0,0,0-.11-1.15,1.18,1.18,0,0,1,.2-1,2.38,2.38,0,0,1,1.16-.6c1-.33,2.1-.63,3.18-.87.53-.12,1.07-.22,1.61-.3a5.91,5.91,0,0,1,1.39-.06.92.92,0,0,1,.63.33,1,1,0,0,1,.1.46,2.58,2.58,0,0,0,.23.81c0,.11.17.24.32.19a.25.25,0,0,0,.15-.27c0-.49-.16-.84-.25-1.4,0-.26-.13-.62-.16-.88S437,292,436.93,291.73Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.36,307.73c.16.57,1.2,4.36-.09,5.26s-2.52-1.95-2.52-1.95a17.16,17.16,0,0,0-8.39,2.16c.32.6-.24,2.79-1.67,2.56s-2.41-4.6-2.42-4.66c.19,3.92.68,7,3.5,9.39,3.56,3,9.8-.35,11.38-3.08s1.67-4.6.57-8.56C443.61,308.45,443.49,308.08,443.36,307.73Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.36,307.73c.16.57,1.2,4.36-.09,5.26s-2.52-1.95-2.52-1.95a17.16,17.16,0,0,0-8.39,2.16c.32.6-.24,2.79-1.67,2.56s-2.41-4.6-2.42-4.66c.19,3.92.68,7,3.5,9.39,3.56,3,9.8-.35,11.38-3.08s1.67-4.6.57-8.56C443.61,308.45,443.49,308.08,443.36,307.73Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.39,311.36c.17,1.47,2,.69,1.85-1.4s-2.1-6.8-2.45-10.37c-1-4-1.77-7.95-2.86-7.86a.77.77,0,0,0,0,.15l.35,2a7.5,7.5,0,0,1,.15.87c.34,3,1.48,8.71,2.09,11.4A39.12,39.12,0,0,1,440.39,311.36Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.94,313.08a37,37,0,0,1-1.56-5c-.66-2.66-2.18-8.21-3.22-11.06a5.7,5.7,0,0,1-.55-1.62c-.12-.4-.24-.91-.35-1.33l0-.09c-.65.36-.52,2-.21,4,.26,1.16.65,2.58,1.17,4.29,1.29,3.35,1.63,8.46,2.45,10.39S433.44,314.47,432.94,313.08Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.27,313.34a.42.42,0,0,0,.14-.06,16.67,16.67,0,0,1,8.27-1.92.46.46,0,0,0,.47-.3c0-.17-.11-.33-.32-.34a17.36,17.36,0,0,0-8.85,2.07c-.19.11-.25.31-.13.44A.42.42,0,0,0,432.27,313.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,310.28l.13,0a20.57,20.57,0,0,1,9.27-2.16.44.44,0,0,0,.45-.31c0-.17-.11-.32-.33-.33a21.54,21.54,0,0,0-9.79,2.28c-.19.11-.26.31-.15.45A.42.42,0,0,0,431,310.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.85,305.09a.45.45,0,0,0,.32-.26c.06-.18-.07-.34-.29-.36a17.73,17.73,0,0,0-9.78,2.21.28.28,0,0,0-.13.44.46.46,0,0,0,.56.05s4.51-2.58,9.15-2.07A.47.47,0,0,0,439.85,305.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.28,302.27a.42.42,0,0,0,.32-.25c.06-.18-.07-.34-.28-.37a16.07,16.07,0,0,0-10,2.22.28.28,0,0,0-.09.44.49.49,0,0,0,.57,0,15.27,15.27,0,0,1,9.29-2.06A.55.55,0,0,0,439.28,302.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.62,299.11a.44.44,0,0,0,.32-.25c.06-.18-.06-.34-.28-.37-5.15-.7-9.85,2.19-10,2.31a.29.29,0,0,0-.11.45.46.46,0,0,0,.56,0c.05,0,4.58-2.82,9.37-2.16A.55.55,0,0,0,438.62,299.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.62,180c2.85,28.11,5.08,66.41,5.08,66.41.24,2.14,1.84,5.77,3.11,16.29,1.34,11.1,2.69,31.92,2.69,31.92s-7.69,4.36-14,2.4c0,0-6.88-29.5-10.41-42.54-3.34-12.34-8.65-35.75-8.65-35.75l-2.74,23.35s.61,8,.5,13.63c-.13,6.54-2.47,36.46-2.47,36.46s-10.53,4.49-17.19-.37c0,0-1.05-41-1.41-48.88-.71-15.4.42-45.31.54-65.22Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.62,180c2.85,28.11,5.08,66.41,5.08,66.41.24,2.14,1.84,5.77,3.11,16.29,1.34,11.1,2.69,31.92,2.69,31.92s-7.69,4.36-14,2.4c0,0-6.88-29.5-10.41-42.54-3.34-12.34-8.65-35.75-8.65-35.75l-2.74,23.35s.61,8,.5,13.63c-.13,6.54-2.47,36.46-2.47,36.46s-10.53,4.49-17.19-.37c0,0-1.05-41-1.41-48.88-.71-15.4.42-45.31.54-65.22Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.4,218.7l-3.1-15.36s-7.66-.94-11.66-4.37c0,0,2.63,4.59,9.88,6.25l3,13.57-.9,23.26Z",
    style: {
      fill: "#845EC2",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.1,188.67a25.45,25.45,0,0,0,3.26-2,25.17,25.17,0,0,0,4.31-4,50,50,0,0,1,4.19-4.17c2.46-2.28,5-4.45,7.56-6.66,3.66-3.19,4.26-4.41,6.46-10,1.05-2.65,7.62-18.52,7.62-18.52L391.63,125c-5.93-.64-8.79,2.37-11.55,8.31-3,6.49-9,24.67-9,24.67-2.64,3-6,7.64-8.57,10.7-1.18,1.39-2.41,2.76-3.67,4.08a9.24,9.24,0,0,1-3.76,2.42,26.14,26.14,0,0,1-4.89.89c-2.73.48-5.29,2.15-8,2.35-.58,0-1.26.06-1.59.54s.19,1.21.76,1.65a3.58,3.58,0,0,0,1.37.63,12.74,12.74,0,0,0,4.73.14c.4,0,.93,0,1,.41s-.2.5-.43.66c-2.6,1.8-6,1.77-9.05,2.7-.58.18-1.26.55-1.24,1.16s.5.84.94,1.1l3.26,1.89a11.23,11.23,0,0,0,2.32,1.11,10.79,10.79,0,0,0,2.66.16,25.33,25.33,0,0,1,2.59.54,3.9,3.9,0,0,0,1.54-.18,22.81,22.81,0,0,0,3.3-1A23.92,23.92,0,0,0,357.1,188.67Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,125.06a10.52,10.52,0,0,0-6.41,1.8c-1.94,1.44-3.08,2.29-5.69,7.81S370.8,158,370.8,158l-10.49,13.26s1.74-.29,4.88,2.37a11.73,11.73,0,0,1,3.41,5.12s8.36-6.81,9.73-8.08c2.87-2.68,4-4.18,4.86-5.8,2.25-4.35,7.29-16,7.29-16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.43,124.32c-5.06.25-7.56,1.33-9.95,4.58-1.6,2.18-2.8,4.94-4.75,10s-5.29,14.48-5.29,14.48,1.19,3.22,5.72,5.65,7.27,1.73,7.27,1.73L391,149Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.43,124.32c-5.06.25-7.56,1.33-9.95,4.58-1.6,2.18-2.8,4.94-4.75,10s-5.29,14.48-5.29,14.48,1.19,3.22,5.72,5.65,7.27,1.73,7.27,1.73L391,149Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.81,179.19a11.75,11.75,0,0,1-7.95,2.11A5.74,5.74,0,0,0,357.81,179.19Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.14,128.16s5,4,2.92,14a148.11,148.11,0,0,0-2.68,19.92c-.24,5.3.75,23.1.75,23.1-7.77,9.73-41.24,8-45.58-.56,0,0-1.25-34.95,1.5-47,1.56-6.82,4.84-11.37,7.37-13.35l9-1.21,10.32-.36Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.14,128.16s5,4,2.92,14a148.11,148.11,0,0,0-2.68,19.92c-.24,5.3.75,23.1.75,23.1-7.77,9.73-41.24,8-45.58-.56,0,0-1.25-34.95,1.5-47,1.56-6.82,4.84-11.37,7.37-13.35l9-1.21,10.32-.36Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.74,122.75l7.28,2.4a52.27,52.27,0,0,1-5.64,7.34c-2.78,2.92-9.17,5.37-13.76,7.17-2.57-4.09-3.21-6.8-2.81-10.58a32.52,32.52,0,0,1,1.12-5.5l3.49-.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.53,142.17c-4.06-.2-10.11-1-10.11-1l.38-2.42s6.06.76,10.12,1Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.79 158.41 395.1 165.52 405.68 197.43 405.13 198.14 378.17 190.84 366.24 159.12 366.79 158.41",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.55 166.23 405.13 198.14 405.68 197.43 395.1 165.52 394.55 166.23",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.24 159.12 394.55 166.23 405.13 198.14 378.17 190.84 366.24 159.12",
    style: {
      opacity: 0.25
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M375.12,165l-.33-1.07c-.18-.6,1.45-.43,3.66.37l5.08,1c2.2.79,4.27,1.35,4.45,1.94l.33,1.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M373,160.24c-.12-.38.51-.36,1.41-.21l1.63.39s-.79-1.52,3-.86c4.21.73,4.49,2.78,4.49,2.78a19.78,19.78,0,0,0,2,.53c1.41.32,1.59.57,1.73.94l.27.68-14.43-3.62S373.14,160.61,373,160.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.69,162.2c1.35.46,1.91.7,2.19,1.61s.41,1.48.41,1.48l7.54,2.19s-.54-1.53-.68-2,.81-.61,2.13-.14l-.42-1.28-11.61-2.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.74,165.08l-.33-1.07c-.18-.59,1.46-.43,3.66.37l5.09,1c2.2.8,4.26,1.35,4.44,2l.33,1.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.5,143.74c-2.85-10.86-6.33-13.63-12.15-14.81-5.79,9.35-2.27,23.06-2.27,23.06l4.6,15.84c-1.07.95-16.72,10.8-19.58,11.82a8.07,8.07,0,0,1-4.06-.32c-2.82-.87-4.77-.54-7.47-.34l1.27,3.83c-4.28,1.57-8.85,1.56-13.34,1.72-.43,0-1,.1-1.12.5a1,1,0,0,0,.39,1,4.32,4.32,0,0,1,.89.75c.34.51.21,1.18.32,1.78a4.7,4.7,0,0,0,1.4,2.26,11.15,11.15,0,0,0,2.28,2c2.78,1.64,7,1.73,10.11,1.14a33.6,33.6,0,0,0,6.16-2c1.88-.75,13.36-4.49,14.72-5,10.12-3.85,23.54-8.11,24.23-13S443.67,155.77,440.5,143.74Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.19,128.62c-.86.91-4.25,7-3.66,14.16s.68,6.62,1.56,10.18,4.29,14.59,4.29,14.59l-14.47,9.56a8.75,8.75,0,0,1,4,3.94c1.79,3.14,1.65,5.78.79,6.6,0,0,3.48-1,8.71-2.86a125,125,0,0,0,14.45-6.43c1.79-1,3.58-2.91,3.42-5.39s-.53-6.59-2.71-14.93-5.1-20.45-7.46-24.25S428.19,128.62,428.19,128.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,127.76c7.83,2.26,9.62,3.45,11.79,9.37a237,237,0,0,1,6.6,23.57c-3.43,3.41-10.84,4-16,4.08l-3.81-12.63C424.4,147,420.31,135.91,427,127.76Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,127.76c7.83,2.26,9.62,3.45,11.79,9.37a237,237,0,0,1,6.6,23.57c-3.43,3.41-10.84,4-16,4.08l-3.81-12.63C424.4,147,420.31,135.91,427,127.76Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.94,95.48a4.93,4.93,0,0,0-3.78-3.31c-.8-3.29-5.65-7.11-12.29-6.25s-9.89,2.91-12,7-.29,6.84-.29,6.84l19.45-1.34a17.3,17.3,0,0,0,.25,2.77c.48,2.95,3.36,6.4,3.36,6.4l0,4.14.24,5.94a3.83,3.83,0,0,0,2.09-1.91c.64-1.43,1.27-3.62,2.19-8.69S419.85,97.75,418.94,95.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.7,98.28a3.44,3.44,0,0,0-.77-.54,3.57,3.57,0,0,0-.92-.18,8.41,8.41,0,0,1-1.87-.24,5.57,5.57,0,0,1-1.72-.95,1.88,1.88,0,0,0-1.8-.5c-.3.13-.05.56.17.61a3,3,0,0,1,.94.54c.22.17.43.34.65.49a5.13,5.13,0,0,0,1.79.75,6.43,6.43,0,0,0,1.91,0c.45,0,1.21-.21,1.61,0C416.7,98.34,416.72,98.3,416.7,98.28Zm-1.19,1.27a3,3,0,0,0-.92-.18,8.49,8.49,0,0,1-1.88-.24,5.71,5.71,0,0,1-1.72-1,1.84,1.84,0,0,0-1.8-.49c-.3.13-.05.55.18.6a3.09,3.09,0,0,1,.94.55c.22.16.42.33.65.49a5.22,5.22,0,0,0,1.79.74,6.12,6.12,0,0,0,1.91,0c.45,0,1.21-.22,1.6,0,0,0,0,0,0,0A3.07,3.07,0,0,0,415.51,99.55Zm-.43,1.8a3.57,3.57,0,0,0-.92-.18,8.41,8.41,0,0,1-1.87-.24,5.68,5.68,0,0,1-1.72-1,1.88,1.88,0,0,0-1.8-.5c-.3.13,0,.55.17.61a3,3,0,0,1,.94.54c.22.17.43.34.65.49a4.93,4.93,0,0,0,1.79.74,6.12,6.12,0,0,0,1.91,0c.45,0,1.21-.21,1.61,0,0,0,0,0,0,0A3.44,3.44,0,0,0,415.08,101.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.92,113a2.79,2.79,0,0,1-3.75-.2l-.18,13a13.45,13.45,0,0,1-12.53,5.16c-2.21-.23-4.2-2.62-2.54-5.67l-.07-3.24a26.29,26.29,0,0,1-2.87-.13c-2.74-.25-4.59-2.3-5.59-5.19-1.6-4.65-1.87-12.93.05-21.48,3.42-3,12.32-3.14,19,.5,0,5.43,1.69,7.74,1.8,9.71a5.2,5.2,0,0,0,1.27,1.45c1,.8,1.72-1.49,2.5-2.41s3.44-2.29,5,.5S420.74,111.63,418.92,113Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.41,100.66l2.88,1.55a1.7,1.7,0,0,0-.69-2.27A1.6,1.6,0,0,0,403.41,100.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.23,101.44l3.1-1.12a1.58,1.58,0,0,0-2.05-1A1.73,1.73,0,0,0,392.23,101.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,103.93a1.34,1.34,0,1,1-1.38-1.3A1.35,1.35,0,0,1,405,103.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.6,103.86a1.34,1.34,0,1,1-1.37-1.3A1.22,1.22,0,0,1,395.6,103.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.79 101.75 399.24 110.31 394.66 108.94 399.79 101.75",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.37,103.67a1,1,0,0,0-.34-.22l-.23,0a2.63,2.63,0,0,0-.49-.07,2.41,2.41,0,0,0-1,.11c-.08,0-.05.21,0,.23a8.88,8.88,0,0,0,1,0l.42.06.23.06.1,0,.14,0h.08C408.46,103.93,408.43,103.72,408.37,103.67Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.44,104.88l-.14-.13a1.87,1.87,0,0,0-.51-.2l-.3-.06a1.14,1.14,0,0,0-.32,0c-.11,0-.07.25,0,.26l.56.13.24.09.24.11c.07,0,.2.1.25,0A.19.19,0,0,0,407.44,104.88Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.75,103.79h0l-.06,0S390.73,103.79,390.75,103.79Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.24,103.58a1.15,1.15,0,0,0-.37-.12l-.46,0h-.53a.27.27,0,0,0-.21.09c-.09.1,0,.26.09.31l.07,0a1,1,0,0,0,.38,0H392a.59.59,0,0,0,.32-.05C392.34,103.77,392.31,103.63,392.24,103.58Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.77 103.8 390.76 103.8 390.76 103.8 390.77 103.8",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.26,104.5a1,1,0,0,0-.35,0l-.31,0-.55,0a.17.17,0,0,0-.13.23.3.3,0,0,0,.27.21h.05a.66.66,0,0,0,.14,0h.13l.29,0,.29-.07c.08,0,.19-.06.23-.14S392.35,104.53,392.26,104.5Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.17,105Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.12,97.59a5,5,0,0,0-2.49,0,13.58,13.58,0,0,1-2.54.25c-1.56-.06-3.17-1-4.74-.53,0,0,0,.09,0,.09a6,6,0,0,1,2.46.34,10.05,10.05,0,0,0,2.34.54,9.65,9.65,0,0,0,2.57-.28c.4-.08.79-.16,1.19-.22a7.89,7.89,0,0,0,1.2-.18S404.15,97.6,404.12,97.59Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.25,104.7c-.2,5.83-2.2,6.26-4.27,6.62-2.73.49-4.1-1-9-.91-3,0-3.9.93-5.58,1.65-1.24.53-2.54.47-2.75-.73a41.83,41.83,0,0,1-.45-7.53,55.09,55.09,0,0,0,.06,10.57c.44,2.74,1.2,5.29,2.73,6.55,2.12,1.75,6.54,2,12,.68s7.47-3.13,8.11-5.07c2-6.31,1.17-9.27,1.88-10.47S412.25,104.7,412.25,104.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.67,112.15c2.8-.1,3.72.4,3.88,2.31.22,2.74.1,3.67-.95,3.82-1.23.19-2.13.27-2.19-.5a3.06,3.06,0,0,1,.16-1.76c.43-.53.27-.61-.95-.56s-1.21.26-.85.63.26,1.22.27,1.76-.13.82-1.89.67c-1.55-.12-1.3-1.36-1.3-3.72C395.85,113.21,396.5,112.25,399.67,112.15Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,112.83l-3.72.56a1.85,1.85,0,0,0,2.1,1.63A2,2,0,0,0,401.5,112.83Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,113.4a1.65,1.65,0,0,1,.45,0,1.93,1.93,0,0,1-1.59,1.59,1.71,1.71,0,0,1-.6,0A1.71,1.71,0,0,1,401,113.4Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-2--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.82,275.85a2,2,0,0,0-.82,1.79,6.14,6.14,0,0,0,2.78,4.81,2,2,0,0,0,2,.19l3.36-1.93a2,2,0,0,0,.81-1.79,6.15,6.15,0,0,0-2.77-4.81,2,2,0,0,0-2-.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.78,282.45a1.69,1.69,0,0,0,2.77-1.6,6.15,6.15,0,0,0-2.77-4.81,1.7,1.7,0,0,0-2.78,1.6A6.14,6.14,0,0,0,302.78,282.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.78,280.69A.76.76,0,0,0,304,280a2.77,2.77,0,0,0-1.25-2.17.76.76,0,0,0-1.25.72A2.77,2.77,0,0,0,302.78,280.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.57,286.11a2,2,0,0,0-.81,1.79,6.15,6.15,0,0,0,2.77,4.81,2,2,0,0,0,2,.19l3.36-1.93a2,2,0,0,0,.81-1.8,6.13,6.13,0,0,0-2.77-4.8,2,2,0,0,0-2-.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.53,292.71a1.7,1.7,0,0,0,2.78-1.6,6.14,6.14,0,0,0-2.78-4.81,1.69,1.69,0,0,0-2.77,1.6A6.15,6.15,0,0,0,320.53,292.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.53,291a.89.89,0,0,0,.89.09.87.87,0,0,0,.37-.81,2.78,2.78,0,0,0-1.26-2.17.76.76,0,0,0-1.25.72A2.77,2.77,0,0,0,320.53,291Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.55,267.64a2,2,0,0,0-.81,1.8,6.12,6.12,0,0,0,2.77,4.8,1.93,1.93,0,0,0,2,.2l3.36-1.93a2,2,0,0,0,.81-1.8,6.12,6.12,0,0,0-2.77-4.8,1.93,1.93,0,0,0-2-.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.51,274.24a1.69,1.69,0,0,0,2.78-1.6,6.13,6.13,0,0,0-2.78-4.8,1.93,1.93,0,0,0-2-.2,2,2,0,0,0-.81,1.8A6.12,6.12,0,0,0,352.51,274.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.51,272.49a.77.77,0,0,0,1.26-.73,2.8,2.8,0,0,0-1.26-2.17.87.87,0,0,0-.88-.09.9.9,0,0,0-.37.82A2.77,2.77,0,0,0,352.51,272.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,265.46a.79.79,0,0,0-.47-.65L335.1,250.73a2.52,2.52,0,0,0-2.27,0L328,253.52a1.31,1.31,0,0,0-.66,1.13v2.06a1.33,1.33,0,0,0,.17.66l.22.37-.23.17L312,266.86a4.09,4.09,0,0,1-2.43.4l-2.75-.53a4.17,4.17,0,0,0-2.43.41l-4.83,2.79a.81.81,0,0,0-.47.66v2.05a.79.79,0,0,0,.47.66L324,287.37a2.46,2.46,0,0,0,2.27,0l4.83-2.79a1.3,1.3,0,0,0,.66-1.15v-2.05a1.24,1.24,0,0,0-.18-.64l-.21-.38a1.37,1.37,0,0,1,.23-.17L347,271.25a4.09,4.09,0,0,1,2.43-.41l2.75.53a4,4,0,0,0,2.42-.41l4.84-2.79a.81.81,0,0,0,.47-.66Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,265.46a.79.79,0,0,0-.47-.65L335.1,250.73a2.52,2.52,0,0,0-2.27,0L328,253.52a1.31,1.31,0,0,0-.66,1.13v2.06a1.33,1.33,0,0,0,.17.66l.22.37-.23.17L312,266.86a4.09,4.09,0,0,1-2.43.4l-2.75-.53a4.17,4.17,0,0,0-2.43.41l-4.83,2.79a.81.81,0,0,0-.47.66v2.05a.79.79,0,0,0,.47.66L324,287.37a2.46,2.46,0,0,0,2.27,0l4.83-2.79a1.3,1.3,0,0,0,.66-1.15v-2.05a1.24,1.24,0,0,0-.18-.64l-.21-.38a1.37,1.37,0,0,1,.23-.17L347,271.25a4.09,4.09,0,0,1,2.43-.41l2.75.53a4,4,0,0,0,2.42-.41l4.84-2.79a.81.81,0,0,0,.47-.66Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.83,250.73,328,253.52a1.31,1.31,0,0,0-.49,1.79l.47.81a1.31,1.31,0,0,1-.48,1.79L312,266.86a4.09,4.09,0,0,1-2.43.4l-2.75-.53a4.17,4.17,0,0,0-2.43.41l-4.83,2.79a.7.7,0,0,0,0,1.32L324,285.32a2.52,2.52,0,0,0,2.27,0l4.83-2.79a1.31,1.31,0,0,0,.48-1.79l-.46-.81a1.31,1.31,0,0,1,.48-1.79L347,269.19a4.09,4.09,0,0,1,2.43-.4l2.75.53a4.12,4.12,0,0,0,2.42-.41l4.84-2.79c.63-.37.63-.95,0-1.31L335.1,250.73A2.52,2.52,0,0,0,332.83,250.73Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.83,250.73,328,253.52a1.31,1.31,0,0,0-.49,1.79l.47.81a1.31,1.31,0,0,1-.48,1.79L312,266.86a4.09,4.09,0,0,1-2.43.4l-2.75-.53a4.17,4.17,0,0,0-2.43.41l-4.83,2.79a.7.7,0,0,0,0,1.32L324,285.32a2.52,2.52,0,0,0,2.27,0l4.83-2.79a1.31,1.31,0,0,0,.48-1.79l-.46-.81a1.31,1.31,0,0,1,.48-1.79L347,269.19a4.09,4.09,0,0,1,2.43-.4l2.75.53a4.12,4.12,0,0,0,2.42-.41l4.84-2.79c.63-.37.63-.95,0-1.31L335.1,250.73A2.52,2.52,0,0,0,332.83,250.73Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.13,139.91V266.43a.51.51,0,0,0,.29.41,1.59,1.59,0,0,0,1.41,0,.51.51,0,0,0,.3-.41V139.91a1,1,0,0,0-1-1,1,1,0,0,0-.7.3A1,1,0,0,0,317.13,139.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.19,157.21a.58.58,0,0,0,.31-.08l1-.58a1.41,1.41,0,0,1,1.38,0,2.57,2.57,0,0,0,2.6,0l.55-.31a2.49,2.49,0,0,0,.93-.92l1.58-2.63a1.47,1.47,0,0,1,.5-.49l20.36-11.76a1.41,1.41,0,0,1,1.38,0,2.59,2.59,0,0,0,2.61,0l.53-.31a2.5,2.5,0,0,0,1-.95l1.46-2.53a1.33,1.33,0,0,1,.5-.5l1.53-.89a.6.6,0,0,0,.23-.83.61.61,0,0,0-.84-.23l-1.53.89a2.5,2.5,0,0,0-1,.95l-1.46,2.53a1.33,1.33,0,0,1-.5.5l-.53.31a1.36,1.36,0,0,1-1.38,0,2.64,2.64,0,0,0-2.61,0l-20.37,11.76a2.7,2.7,0,0,0-.93.91l-1.58,2.64a1.44,1.44,0,0,1-.49.49l-.55.31a1.36,1.36,0,0,1-1.38,0,2.64,2.64,0,0,0-2.61,0l-1,.58a.61.61,0,0,0-.23.84A.63.63,0,0,0,298.19,157.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.39,178.43l-.13.87c0,.21-.2.27-.38.14s-.5-.14-.54.19l-.35,3.15a1.06,1.06,0,0,0,.36.88l1.41,1.16c.23.19.46.12.51-.16l.55-3a1.1,1.1,0,0,0-.36-.92l-.12-.1a.83.83,0,0,1-.27-.67l.09-.56c0-.31.28-.37.53-.14s.49.44.76.65a1.08,1.08,0,0,1,.35.79l0,5.06a1.31,1.31,0,0,0,.61,1.22c.41.24.64,0,.65-.44l0-4.87c0-.3.2-.44.44-.3s.28.18.43.26a13.35,13.35,0,0,0,2.19,1l.48.16a.85.85,0,0,1,.54.7l.06.56c0,.27-.09.43-.28.38s-.47.12-.41.52l.54,3.89a1.07,1.07,0,0,0,.55.83l1.52.55c.25.09.43-.12.4-.48l-.34-3.8a1.06,1.06,0,0,0-.55-.87l-.13-.06a.78.78,0,0,1-.41-.63l-.09-.8c0-.28.09-.47.27-.46a2.61,2.61,0,0,0,3-2.25c.44-2.6-.07-11.19-.38-14.9s-1.33-4.95-2.18-5.88a10.49,10.49,0,0,1-2.34-3.11c-.62-1.41-1.08-2.63-2.48-3.43s-1.87-.14-2.49.56-1.48.48-2.33.42-1.4.56-1.71,3.91-1.13,11.28-.86,13.91a11,11,0,0,0,2.6,5.24A1.1,1.1,0,0,1,298.39,178.43Zm3.69-22.38c0-.63.38-.92.85-.65a2,2,0,0,1,.85,1.63c0,.62-.38.91-.85.64A2,2,0,0,1,302.08,156.05Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.22,224.58c-7.93,0-22.93-5-22.93-23.79V179.42a.49.49,0,0,1,1,0v21.37c0,18,14.36,22.81,22,22.81s15.14-4.19,18-10c1.29-2.63,2.1-6.71-1.36-11.16a.49.49,0,1,1,.77-.6,11.08,11.08,0,0,1,1.47,12.19C342.08,220.16,334.16,224.58,326.22,224.58Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.89,161.93c.33-3.41.73-6.31,2.29-5.34s5.12,3.09,6.23,3.59a5.64,5.64,0,0,1,2.78,3,30.72,30.72,0,0,1,.92,7.39c.05,1.73-4-.33-7-2S296.89,161.93,296.89,161.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.64,170a.17.17,0,0,1,0,.1c.21,3.43.41,7.45.5,9.37h0a2.09,2.09,0,0,1-2.12,2.2,8.93,8.93,0,0,1-4.12-1.43c-4.63-2.67-6.08-5.84-6.33-7h0a11,11,0,0,1-.21-1.81,70.71,70.71,0,0,1,.48-9.25.18.18,0,0,1,.19-.16,4,4,0,0,1,2.29,1.21,21.5,21.5,0,0,0,6.57,4.87A6.61,6.61,0,0,1,308.64,170Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.64,170a.17.17,0,0,1,0,.1c.21,3.43.41,7.45.5,9.37h0a2.09,2.09,0,0,1-2.12,2.2,8.93,8.93,0,0,1-4.12-1.43c-4.63-2.67-6.08-5.84-6.33-7h0a11,11,0,0,1-.21-1.81,70.71,70.71,0,0,1,.48-9.25.18.18,0,0,1,.19-.16,4,4,0,0,1,2.29,1.21,21.5,21.5,0,0,0,6.57,4.87A6.61,6.61,0,0,1,308.64,170Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.41,182.73a.36.36,0,0,0,.36-.35l.1-3.67a.37.37,0,0,0-.35-.37h0a.36.36,0,0,0-.36.35l-.1,3.67a.35.35,0,0,0,.35.37Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.41,182.73a.36.36,0,0,0,.36-.35l.1-3.67a.37.37,0,0,0-.35-.37h0a.36.36,0,0,0-.36.35l-.1,3.67a.35.35,0,0,0,.35.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.64,170a.17.17,0,0,1,0,.1c.21,3.43.41,7.45.5,9.37a2.09,2.09,0,0,1-2.12,2.2,8.93,8.93,0,0,1-4.12-1.43c-4.63-2.67-6.08-5.84-6.33-7a11,11,0,0,1-.21-1.81c0-.26,0-.54,0-.83.14,2.94,3.89,6.66,7.21,7.42s2.66-3.11,2.29-9.94l0,0A6.61,6.61,0,0,1,308.64,170Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.47,172a41.68,41.68,0,0,0,7.74,4.47c.12.05.2,0,.2-.17v-2.55a.54.54,0,0,0-.21-.42q-3.85-2.47-7.72-4.46c-.12-.06-.21,0-.21.18v2.55A.51.51,0,0,0,298.47,172Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.22,157.74c2.4,1.24,4.06,2.17,4.09,2.83s-3.23-1-4.25-.19-1,.35-1-.59S298.22,157.23,299.22,157.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.87,155.49a1.36,1.36,0,0,1-1.38,0,2.64,2.64,0,0,0-2.61,0l-1,.58a.61.61,0,0,0-.23.84.63.63,0,0,0,.53.3.58.58,0,0,0,.31-.08l1-.58a1.41,1.41,0,0,1,1.38,0,2.57,2.57,0,0,0,2.6,0",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.43,267.52a3.54,3.54,0,0,0,2.08,2.89,11.1,11.1,0,0,0,10,0,3.53,3.53,0,0,0,2.07-2.89c0-1,0-47.17,0-48.22a3.51,3.51,0,0,0-2.08-2.89,11.08,11.08,0,0,0-10,0,3.53,3.53,0,0,0-2.08,2.89C322.42,220.35,322.43,266.47,322.43,267.52Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.43,267.52a3.54,3.54,0,0,0,2.08,2.89,11.1,11.1,0,0,0,10,0,3.53,3.53,0,0,0,2.07-2.89c0-1,0-47.17,0-48.22a3.51,3.51,0,0,0-2.08-2.89,11.08,11.08,0,0,0-10,0,3.53,3.53,0,0,0-2.08,2.89C322.42,220.35,322.43,266.47,322.43,267.52Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.54,216.41a3.06,3.06,0,0,1,0,5.79,11.08,11.08,0,0,1-10,0,3.05,3.05,0,0,1,0-5.79A11.1,11.1,0,0,1,334.54,216.41Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.14,179.85l10.54,6.08a2.71,2.71,0,0,1,1.15,1.62l3.35,17.39V207l-.89.52v8.2l-24,13.85-16-9.23V194.75a2.1,2.1,0,0,1,.94-1.64l23-13.26A2.06,2.06,0,0,1,333.14,179.85Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.14,179.85l10.54,6.08a2.71,2.71,0,0,1,1.15,1.62l3.35,17.39V207l-.89.52v8.2l-24,13.85-16-9.23V194.75a2.1,2.1,0,0,1,.94-1.64l23-13.26A2.06,2.06,0,0,1,333.14,179.85Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.19,220.84l-.89-.51v9.23l-16-9.23V194.75a2,2,0,0,1,.28-.93l13.27,7.65,3.33,17.32Z",
    style: {
      fill: "#845EC2",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.83,187.55l3.35,17.39-24,13.85-3.35-17.39a1.65,1.65,0,0,1,.74-1.62L343.68,187A.72.72,0,0,1,344.83,187.55Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.19,220.84l-.89-.51v9.23l24-13.85v-8.2Z",
    style: {
      fill: "#845EC2",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.68,191.88l2.47,12.84a.81.81,0,0,1-.37.81l-16.55,9.56a.37.37,0,0,1-.58-.27L323.18,202a.81.81,0,0,1,.37-.81l16.55-9.56A.37.37,0,0,1,340.68,191.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.21,191.39l.2,1.06a.1.1,0,0,1,0,.1l-2.08,1.2s-.07,0-.08,0l-.2-1.06a.1.1,0,0,1,.05-.11l2.08-1.2S344.2,191.35,344.21,191.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.66,193.75l.21,1.06a.14.14,0,0,1-.05.11l-2.08,1.2a.05.05,0,0,1-.08,0l-.2-1.06a.12.12,0,0,1,.05-.1l2.08-1.2S344.66,193.71,344.66,193.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.12,196.12l.2,1.06a.12.12,0,0,1-.05.1l-2.08,1.2s-.07,0-.07,0l-.21-1.06a.14.14,0,0,1,0-.11l2.08-1.2A.05.05,0,0,1,345.12,196.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.57,198.48l.2,1.06a.1.1,0,0,1,0,.11l-2.08,1.2a0,0,0,0,1-.07,0l-.2-1.07a.1.1,0,0,1,0-.1l2.08-1.2S345.56,198.44,345.57,198.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,200.85l.2,1.06a.09.09,0,0,1-.05.1l-2.08,1.2s-.06,0-.07,0l-.2-1.06a.11.11,0,0,1,0-.11l2.09-1.2S346,200.81,346,200.85Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.19 220.84 348.18 206.99 348.18 204.94 324.19 218.79 324.19 220.84",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.3,213.73a.77.77,0,0,0-.79.07,2.49,2.49,0,0,0-1.12,1.95.77.77,0,0,0,.33.72l1.35.78a.77.77,0,0,0,.79-.08,2.46,2.46,0,0,0,1.13-1.94.77.77,0,0,0-.33-.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.86,217.17a.77.77,0,0,1-.79.08.8.8,0,0,1-.33-.72,2.51,2.51,0,0,1,1.12-1.95.81.81,0,0,1,.8-.07.77.77,0,0,1,.33.72A2.46,2.46,0,0,1,341.86,217.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.65,216.41a.82.82,0,0,0-.8.08,2.48,2.48,0,0,0-1.12,1.94.8.8,0,0,0,.33.73l1.36.78a.77.77,0,0,0,.79-.08,2.47,2.47,0,0,0,1.12-1.94.8.8,0,0,0-.33-.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.21,219.86a.68.68,0,0,1-1.12-.65,2.48,2.48,0,0,1,1.12-1.94.68.68,0,0,1,1.12.65A2.47,2.47,0,0,1,337.21,219.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.63,221.53a.69.69,0,0,1-1.13-.64,2.5,2.5,0,0,1,1.13-1.95.68.68,0,0,1,1.12.65A2.45,2.45,0,0,1,331.63,221.53Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.37,219.6a.46.46,0,0,0-.46,0,1.44,1.44,0,0,0-.65,1.13.46.46,0,0,0,.19.42l2.33,1.34a.46.46,0,0,0,.46,0,1.45,1.45,0,0,0,.65-1.13.45.45,0,0,0-.19-.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.24,222.49a.46.46,0,0,1-.46,0,.45.45,0,0,1-.19-.42,1.45,1.45,0,0,1,.65-1.13.46.46,0,0,1,.46,0,.45.45,0,0,1,.19.42A1.45,1.45,0,0,1,334.24,222.49Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.39,224a.8.8,0,0,1-.79.08.78.78,0,0,1-.33-.73,2.48,2.48,0,0,1,1.12-1.94.68.68,0,0,1,1.12.65A2.48,2.48,0,0,1,327.39,224Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.13,222a.44.44,0,0,0-.46.05,1.45,1.45,0,0,0-.65,1.12.46.46,0,0,0,.19.42l2.33,1.35a.49.49,0,0,0,.46-.05,1.44,1.44,0,0,0,.65-1.13.46.46,0,0,0-.19-.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,224.92a.49.49,0,0,1-.46.05.46.46,0,0,1-.19-.42,1.44,1.44,0,0,1,.65-1.13.49.49,0,0,1,.46,0,.46.46,0,0,1,.19.42A1.44,1.44,0,0,1,330,224.92Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,214.32a.57.57,0,0,1-.57.06.59.59,0,0,1-.23-.52,1.77,1.77,0,0,1,.8-1.39.57.57,0,0,1,.57-.06.59.59,0,0,1,.23.52A1.77,1.77,0,0,1,345,214.32Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,231.61a.54.54,0,0,0-.55.06,1.69,1.69,0,0,0-.77,1.34.56.56,0,0,0,.22.51l4.23,2.43a.56.56,0,0,0,.55,0,1.71,1.71,0,0,0,.77-1.35.53.53,0,0,0-.22-.5Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,231.61a.54.54,0,0,0-.55.06,1.69,1.69,0,0,0-.77,1.34.56.56,0,0,0,.22.51l4.23,2.43a.56.56,0,0,0,.55,0,1.71,1.71,0,0,0,.77-1.35.53.53,0,0,0-.22-.5Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.64,235.9a.56.56,0,0,1-.55,0,.54.54,0,0,1-.23-.5,1.72,1.72,0,0,1,.78-1.35.56.56,0,0,1,.55,0,.53.53,0,0,1,.22.5A1.71,1.71,0,0,1,337.64,235.9Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.4,234.92v6.46a1.67,1.67,0,0,1-.76,1.31l-7.37,4.25a1.61,1.61,0,0,1-1.51,0l-1.15-.66a1.68,1.68,0,0,1-.76-1.31v-2.35a1.69,1.69,0,0,0-.75-1.32l-3.69-2.13-1-.58a1.67,1.67,0,0,1-.76-1.31v-2.37a1.69,1.69,0,0,1,.76-1.31l7.38-4.24a1.69,1.69,0,0,1,1.52,0l7.35,4.25A1.67,1.67,0,0,1,352.4,234.92Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.4,234.92v6.46a1.67,1.67,0,0,1-.76,1.31l-7.37,4.25a1.61,1.61,0,0,1-1.51,0l-1.15-.66a1.68,1.68,0,0,1-.76-1.31v-2.35a1.69,1.69,0,0,0-.75-1.32l-3.69-2.13-1-.58a1.67,1.67,0,0,1-.76-1.31v-2.37a1.69,1.69,0,0,1,.76-1.31l7.38-4.24a1.69,1.69,0,0,1,1.52,0l7.35,4.25A1.67,1.67,0,0,1,352.4,234.92Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.48,238.92v8.2a1.43,1.43,0,0,1-.72-.18l-1.15-.66a1.68,1.68,0,0,1-.76-1.31v-2.35a1.69,1.69,0,0,0-.75-1.32l-3.69-2.13-1-.58a1.67,1.67,0,0,1-.76-1.31v-2.37a1.71,1.71,0,0,1,.62-1.21c-.27.24-.23.57.14.78l7.37,4.26A1.43,1.43,0,0,0,343.48,238.92Z",
    style: {
      fill: "#845EC2",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.27,238.74l7.37-4.26a.46.46,0,0,0,0-.87l-7.35-4.25a1.63,1.63,0,0,0-1.52,0l-7.38,4.24c-.42.25-.42.64,0,.88l7.37,4.26A1.67,1.67,0,0,0,344.27,238.74Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.85,242.62v2.23l-3.73-2.18a1.44,1.44,0,0,1-.71-1.24v-2.26l3.69,2.13A1.69,1.69,0,0,1,340.85,242.62Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.85,242.62v2.23l-3.73-2.18a1.44,1.44,0,0,1-.71-1.24v-2.26l3.69,2.13A1.69,1.69,0,0,1,340.85,242.62Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.09,239.07l3.74-2.16c.22-.13.4,0,.4.23v4.32a.9.9,0,0,1-.4.7l-3.74,2.16c-.22.13-.41,0-.41-.23v-4.32A.91.91,0,0,1,346.09,239.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,234.52a2.24,2.24,0,0,0,1.32,1.84,7,7,0,0,0,6.37,0,2.24,2.24,0,0,0,1.32-1.84c0-.66,0-.66,0-1.32a2.22,2.22,0,0,0-1.32-1.84,7,7,0,0,0-6.37,0A2.22,2.22,0,0,0,339,233.2C339,233.86,339,233.86,339,234.52Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.7,231.36A2.22,2.22,0,0,1,348,233.2,2.25,2.25,0,0,1,346.7,235a7.07,7.07,0,0,1-6.37,0A2.25,2.25,0,0,1,339,233.2a2.22,2.22,0,0,1,1.32-1.84A7,7,0,0,1,346.7,231.36Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.7,231.36A2.22,2.22,0,0,1,348,233.2,2.25,2.25,0,0,1,346.7,235a7.07,7.07,0,0,1-6.37,0A2.25,2.25,0,0,1,339,233.2a2.22,2.22,0,0,1,1.32-1.84A7,7,0,0,1,346.7,231.36Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,232.86a1.78,1.78,0,0,0,1,1.45,5.53,5.53,0,0,0,5,0,1.76,1.76,0,0,0,1-1.45v-5.63a1.78,1.78,0,0,0-1-1.45,5.53,5.53,0,0,0-5,0,1.76,1.76,0,0,0-1,1.45Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,232.86a1.78,1.78,0,0,0,1,1.45,5.53,5.53,0,0,0,5,0,1.76,1.76,0,0,0,1-1.45v-5.63a1.78,1.78,0,0,0-1-1.45,5.53,5.53,0,0,0-5,0,1.76,1.76,0,0,0-1,1.45Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,225.78a1.53,1.53,0,0,1,0,2.9,5.53,5.53,0,0,1-5,0,1.53,1.53,0,0,1,0-2.9A5.53,5.53,0,0,1,346,225.78Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,225.78a1.53,1.53,0,0,1,0,2.9,5.53,5.53,0,0,1-5,0,1.53,1.53,0,0,1,0-2.9A5.53,5.53,0,0,1,346,225.78Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.26,227.85a.5.5,0,0,0,.29.41,1.55,1.55,0,0,0,1.42,0,.5.5,0,0,0,.29-.41v-2.92a.49.49,0,0,0-.3-.41,1.53,1.53,0,0,0-1.41,0,.48.48,0,0,0-.29.41Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,224.52a.49.49,0,0,1,.3.41.51.51,0,0,1-.3.41,1.59,1.59,0,0,1-1.41,0,.49.49,0,0,1-.29-.41.48.48,0,0,1,.29-.41A1.53,1.53,0,0,1,343,224.52Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.7,226.49a.5.5,0,0,0,.29.41,1.55,1.55,0,0,0,1.42,0,.5.5,0,0,0,.29-.41v-2.92a.5.5,0,0,0-.29-.41,1.61,1.61,0,0,0-1.42,0,.5.5,0,0,0-.29.41Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.41,223.16a.43.43,0,0,1,0,.82,1.61,1.61,0,0,1-1.42,0,.43.43,0,0,1,0-.82A1.61,1.61,0,0,1,345.41,223.16Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--ct-scan--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.88,286c98.88,32.91,207.25-155.63,127.8-223.87a95.78,95.78,0,0,0-12.55-8.67C71.92-11-66,241.13,68.88,286Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M145.77,44a75.17,75.17,0,0,1,37.86,10.37A93.79,93.79,0,0,1,196,62.91c15.15,13,24.05,30.83,26.48,53,2.19,20-1.17,42.72-9.71,65.76-10.54,28.45-28,55-49.1,74.7-22.79,21.27-47.43,32.51-71.27,32.51a73.43,73.43,0,0,1-23.23-3.76c-22.23-7.4-38-20.76-47-39.69-7.93-16.81-10.14-37.92-6.39-61.06a183.19,183.19,0,0,1,16.38-50.2A205.21,205.21,0,0,1,62.24,89c25.61-29,55.27-45,83.53-45m0-1C44.37,43-50.89,246.17,68.88,286a74,74,0,0,0,23.55,3.82c91.3,0,177.42-164.85,104.25-227.69a95.78,95.78,0,0,0-12.55-8.67A76,76,0,0,0,145.77,43Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M122.41,317c98.87,32.9,207.25-155.63,127.8-223.87a95.2,95.2,0,0,0-12.56-8.67C125.45,19.91-12.51,272.09,122.41,317Zm72-158c1.2,28.56-18.75,63.11-44.08,76.36-1.24-27.68,17.88-61.19,41.68-75.06C192.81,159.81,193.62,159.38,194.41,159Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.66,157c0-.5,0-1,0-1.51s0-1.17-.07-1.75c-2.36-48.93-37.16-69.11-80.63-46.8-1.63.84-3.29,1.71-4.93,2.66-48.86,28.46-88.08,97.23-85.53,154,2.41,48,36.25,68.17,78.82,47.44,1.24-.61,2.5-1.24,3.76-1.93,1-.52,2-1.07,2.95-1.64s1.95-1.14,2.91-1.75,2-1.23,3-1.88c.47-.29.92-.6,1.37-.9,43.19-29.13,77.28-90,78.42-141.3v0c0-.85,0-1.69,0-2.54v0C277.68,158.33,277.67,157.64,277.66,157ZM192,160.27c.8-.46,1.6-.89,2.4-1.3A72.24,72.24,0,0,1,191,183c-.12.36-.23.73-.35,1.1s-.19.6-.29.89a98.5,98.5,0,0,1-19.54,33.84c-.3.34-.6.69-.92,1-.47.52-.94,1-1.42,1.53a72.19,72.19,0,0,1-18.18,14C149.09,207.65,168.2,174.14,192,160.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,183c-.12.36-.23.73-.35,1.1s-.19.6-.29.89a101,101,0,0,1-19.54,33.84c-.31.34-.61.69-.92,1-.47.52-.94,1-1.42,1.53a72.19,72.19,0,0,1-18.18,14c-1.24-27.68,17.87-61.19,41.68-75.06.8-.46,1.6-.89,2.4-1.3A72.24,72.24,0,0,1,191,183Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.77,184.38c0,26.63-18.71,59-41.76,72.33-22.26,12.83-40.44,3.22-41.68-21.38.81-.4,1.62-.83,2.42-1.29a71.63,71.63,0,0,0,15.76-12.66c.48-.51,1-1,1.42-1.53.31-.33.61-.68.92-1A101,101,0,0,0,190.39,185c.1-.29.19-.6.29-.89s.24-.74.35-1.1a72.31,72.31,0,0,0,3.48-21.28c0-.93,0-1.84-.1-2.75C216.35,147.72,233.76,158.67,233.77,184.38Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.77,184.38c0,26.63-18.71,59-41.76,72.33-22.26,12.83-40.44,3.22-41.68-21.38.81-.4,1.62-.83,2.42-1.29a71.63,71.63,0,0,0,15.76-12.66c.48-.51,1-1,1.42-1.53.31-.33.61-.68.92-1A101,101,0,0,0,190.39,185c.1-.29.19-.6.29-.89s.24-.74.35-1.1a72.31,72.31,0,0,0,3.48-21.28c0-.93,0-1.84-.1-2.75C216.35,147.72,233.76,158.67,233.77,184.38Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.07,278.15h0c-21,0-35.39-15.84-36.63-40.35C133.93,204,156.13,163.94,186,146.55c1.07-.62,2.07-1.14,3.07-1.67,7.86-4,15.57-6.06,22.93-6.06,21.94,0,36.69,17.63,36.7,43.88,0,32.8-22.26,71.34-50.65,87.75C189.15,275.56,180.42,278.15,172.07,278.15ZM212,141.77c-6.89,0-14.15,1.93-21.57,5.74-1,.5-1.93,1-2.94,1.59-29,16.89-50.54,55.79-49.07,88.56,1.15,22.8,14.37,37.53,33.68,37.54,7.83,0,16.06-2.46,24.47-7.31,27.56-15.92,49.17-53.34,49.18-85.19C245.71,158.22,232.15,141.77,212,141.77Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.19,57.11c-1.76.91-3.54,1.85-5.3,2.87C66.27,90.63,24,164.67,26.78,225.83,28.09,252,38.05,270.42,53.5,279.42c6.79,3.94,47.1,27.17,53.79,31.06-15.45-9-25.41-27.46-26.72-53.59-2.74-61.15,39.5-135.19,92.1-165.84,1.77-1,3.55-2,5.31-2.87,23.23-11.92,44.18-12.57,59.67-3.75-7.26-4.21-46.84-27.05-53.46-30.88C168.66,44.53,147.6,45.1,124.19,57.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M145.88,321.25a74.5,74.5,0,0,1-23.62-3.8,92.35,92.35,0,0,1-20.34-9.51L84.29,297.77c-12.8-7.39-27.46-15.85-31-17.93l-.11-.07c-34.37-18.75-41-51.89-40.54-76.41.23-11.29,3.88-19.77,10.83-25.2,12-9.39,29.62-6.69,36.63-5.1,14.38,3.27,35.67,21.49,43.82,37.51,6.6,13,9.88,27,11,46.91,1.16,21.34,6.81,36.47,16.78,45,7.28,6.2,16.9,8.73,28.58,7.5,38.89-4.08,82-52.09,97.91-94.37,6.31-16.78,9.17-31,11.26-41.3,2.26-11.2,3.75-18.61,7.94-21l.7-.4,0,.81c0,.58.05,1.16.07,1.75s0,1,0,1.5v.21l-.49.1h.49c.39,25.8-7.6,55.05-22.52,82.35s-35.21,50.09-57.38,64.58l-.38-.34.27.41c-1,.63-1.9,1.23-2.86,1.82l-.37-.35.26.42-.66.4-1.67,1-.6.36c-1.15.66-2.09,1.19-3,1.64s-1.63.87-2.44,1.28l-.26.13-1.07.54-.38.18C172,318,158.76,321.25,145.88,321.25ZM46,172.42c-7.21,0-15.44,1.43-21.95,6.52-6.7,5.24-10.22,13.46-10.45,24.44-.46,24.24,6.1,57,40,75.5l.12.07c3.64,2.12,18.3,10.58,31.1,18l17.65,10.19a92.1,92.1,0,0,0,20.14,9.42c19.57,6.51,41.05,4.52,62.12-5.76l.39-.19,1.06-.53.16-.08.32.39-.22-.44c.8-.4,1.61-.82,2.41-1.26s1.81-1,2.95-1.63l.57-.35,1.69-1,.63-.38.13-.08c.94-.58,1.88-1.18,2.82-1.79l.39.33-.27-.41c46.1-30.14,80.27-92.95,79.46-146.1V157c0-.5,0-1,0-1.45v-.08c0-.28,0-.56,0-.84-3.29,2.65-4.7,9.64-6.77,19.89s-5,24.59-11.29,41.45c-8.25,21.95-23.25,44.76-41.14,62.58-19.09,19-39.55,30.52-57.6,32.42-12,1.25-21.82-1.35-29.32-7.74-10.19-8.68-15.95-24.05-17.13-45.67-1.07-19.77-4.31-33.68-10.85-46.52-7.89-15.51-29.27-33.84-43.16-37A64.21,64.21,0,0,0,46,172.42Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "34.15 257.64 34.15 338.59 87.94 369.66 87.94 288.71 34.15 257.64",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.94,288.71c-4.59-2.42-9.12-4.92-13.64-7.44s-9-5.12-13.5-7.67-8.95-5.21-13.39-7.87l-6.66-4c-2.2-1.36-4.42-2.7-6.6-4.09,2.29,1.2,4.56,2.45,6.84,3.67l6.79,3.77c4.53,2.52,9,5.11,13.51,7.67s8.95,5.21,13.39,7.86S83.56,285.94,87.94,288.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.42,317a91.85,91.85,0,0,1-19.76-9.17l4.63,2.67c-8.78-5.19-15-12.65-19.35-21.77v81l171-98.71v-38.7C230.75,289,175.23,334.56,122.42,317Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.94,360.43v4.62l84.23-48.62a89.72,89.72,0,0,1-13.88,3.39Zm136.4-78.75a162.35,162.35,0,0,1-12.92,12.07l47.48-27.41v-4.62Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.94,360.43v4.62l84.23-48.62a89.72,89.72,0,0,1-13.88,3.39Zm136.4-78.75a162.35,162.35,0,0,1-12.92,12.07l47.48-27.41v-4.62Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "34.15 333.99 87.93 365.05 87.94 360.43 34.15 329.54 34.15 333.99",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.93,349.73v-6.28a2.84,2.84,0,0,1,1.27-2.22l1.45-.83c.7-.4,1.27-.07,1.27.74v6.28a2.82,2.82,0,0,1-1.28,2.21l-1.44.83C96.5,350.87,95.93,350.54,95.93,349.73Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.92,345.12v-6.28a2.79,2.79,0,0,1,1.28-2.21l1.44-.84c.7-.4,1.28-.07,1.28.74v6.28a2.83,2.83,0,0,1-1.28,2.21l-1.44.84C104.49,346.26,103.92,345.93,103.92,345.12Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.98 277.37 63.95 291.21 63.95 309.67 39.98 295.82 39.98 277.37",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.21 294.55 63.95 307.11 63.95 291.21 42.21 278.66 42.21 294.55",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.21 294.55 39.98 295.82 63.95 309.67 63.95 307.11 42.21 294.55",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.21 283.27 63.95 295.83 63.95 291.21 42.21 278.66 42.21 283.27",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.95 323.51 79.94 328.13 79.94 337.36 71.95 332.74 71.95 323.51",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.21,310.59a4.28,4.28,0,0,1-2.15-.65l-1.71-1a10,10,0,0,1-4.51-7.81v-8.69h1v8.69a8.88,8.88,0,0,0,4,7l1.71,1a2.12,2.12,0,0,0,3.52-2v-8.7h1v8.7a3.44,3.44,0,0,1-1.5,3.18A2.59,2.59,0,0,1,55.21,310.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.55,345a9.91,9.91,0,0,1-4.84-1.52c-4.76-2.75-8.64-9.52-8.64-15.11v-30h1v30c0,5.27,3.65,11.67,8.14,14.26,2.45,1.41,4.76,1.76,6.18.94a3.28,3.28,0,0,0,1.47-3.06v-7.4h1v7.4a4.25,4.25,0,0,1-2,3.91A4.52,4.52,0,0,1,70.55,345Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.92 326.27 72.6 327.04 72.6 328.16 71.63 328.73 74.54 330.41 75.51 329.85 77.46 329.85 78.78 329.07 73.92 326.27",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.63 328.73 71.63 334.59 74.54 336.28 75.51 335.72 77.46 335.72 78.78 334.94 78.78 329.07 77.46 329.85 75.51 329.85 74.54 330.41 71.63 328.73",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.51 329.85 75.51 335.72 74.54 336.28 74.54 330.41 75.51 329.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.46 329.85 78.78 329.07 78.78 334.94 77.46 335.72 77.46 329.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.72,295.17a1.84,1.84,0,0,0-.76,1.69,5.76,5.76,0,0,0,2.61,4.51,1.84,1.84,0,0,0,1.84.18l1.27-.73a1.85,1.85,0,0,0,.76-1.69,5.75,5.75,0,0,0-2.6-4.51,1.84,1.84,0,0,0-1.84-.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.57,301.37A5.76,5.76,0,0,1,55,296.86a1.84,1.84,0,0,1,.76-1.69,1.86,1.86,0,0,1,1.85.18,5.77,5.77,0,0,1,2.6,4.51,1.59,1.59,0,0,1-2.6,1.51Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.49,289.27a1.85,1.85,0,0,0-.76,1.69,5.77,5.77,0,0,0,2.6,4.51,1.84,1.84,0,0,0,1.85.18l1.27-.73a1.84,1.84,0,0,0,.76-1.69,5.76,5.76,0,0,0-2.61-4.51,1.84,1.84,0,0,0-1.84-.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.33,295.47a5.77,5.77,0,0,1-2.6-4.51,1.85,1.85,0,0,1,.76-1.69,1.83,1.83,0,0,1,1.84.19A5.76,5.76,0,0,1,49.94,294a1.82,1.82,0,0,1-.76,1.68A1.84,1.84,0,0,1,47.33,295.47Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.84,413.38a4.6,4.6,0,0,0-2.23-2.43L241,315.79a12.71,12.71,0,0,0-11.43,0l-63.67,36.59a4.34,4.34,0,0,0-2.31,2.74c0,.18-5.43,14.77-5.43,16s.79,2.38,2.37,3.28l171,98.25a12.73,12.73,0,0,0,11.44,0l69-39.67c2-1.14,2.72-2.71,2.22-4.17C413.9,427.89,409.31,414.84,408.84,413.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.91,352.38l63.67-36.59a12.71,12.71,0,0,1,11.43,0L406.61,411c3.16,1.82,3.16,4.76,0,6.58L343,454.13a12.7,12.7,0,0,1-11.44,0L165.91,359C162.75,357.13,162.75,354.19,165.91,352.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.79,361.19c0-1.19-.79-2.38-2.37-3.29l-128-73.58a12.73,12.73,0,0,0-11.44,0L198.1,305.5c-1.58.9-2.37,2.09-2.37,3.28v50c0,1.19.79,2.38,2.37,3.29l128,73.58a12.73,12.73,0,0,0,11.44,0l36.84-21.18c1.58-.9,2.37-2.09,2.37-3.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.42,357.9l-42.55-24.45V437a11.81,11.81,0,0,0,5.71-1.36l36.84-21.18c1.58-.9,2.37-2.09,2.37-3.28v-50C376.79,360,376,358.81,374.42,357.9Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.42,357.9l-128-73.58a12.73,12.73,0,0,0-11.44,0L198.1,305.5c-1.58.9-2.37,2.09-2.37,3.28v13l99,56.87a10.14,10.14,0,0,1,3.94,4.74l3.21,9.21a10.27,10.27,0,0,0,3.94,4.75l31.83,18.29a6.33,6.33,0,0,0,5.72,0l33.46-19.23v-35.2C376.79,360,376,358.81,374.42,357.9Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.1,305.5l36.84-21.18a12.73,12.73,0,0,1,11.44,0l128,73.58c1.58.91,2.37,2.1,2.37,3.29s-.79,2.38-2.37,3.29l-36.84,21.17a12.73,12.73,0,0,1-11.44,0l-128-73.58c-1.58-.91-2.37-2.1-2.37-3.29S196.52,306.4,198.1,305.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.38,341.57a.62.62,0,0,1-.33-.08L236.51,237.74a.66.66,0,1,1,.66-1.14L417.7,340.34a.66.66,0,0,1,.25.9A.67.67,0,0,1,417.38,341.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.15,254.74a.69.69,0,0,1-.34-.09c-5.8-3.47-10.6-6.78-10.6-12.29a.66.66,0,1,1,1.31,0c0,4.82,4.32,7.79,10,11.16a.65.65,0,0,1,.22.9A.64.64,0,0,1,256.15,254.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.61,267.07a.67.67,0,0,1-.34-.09c-5.8-3.47-10.6-6.78-10.6-12.3a.66.66,0,0,1,1.31,0c0,4.83,4.32,7.8,10,11.17a.66.66,0,0,1-.33,1.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.06,279.4a.66.66,0,0,1-.33-.09c-5.8-3.47-10.61-6.78-10.61-12.3a.66.66,0,1,1,1.32,0c0,4.83,4.32,7.79,10,11.17a.65.65,0,0,1,.23.9A.67.67,0,0,1,299.06,279.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.52,291.73a.58.58,0,0,1-.33-.1c-5.8-3.46-10.61-6.78-10.61-12.29a.66.66,0,1,1,1.32,0c0,4.83,4.32,7.79,10,11.16a.66.66,0,0,1,.23.91A.67.67,0,0,1,320.52,291.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,304.06a.58.58,0,0,1-.33-.1c-5.8-3.46-10.61-6.78-10.61-12.29a.66.66,0,0,1,1.32,0c0,4.83,4.32,7.79,10,11.16a.66.66,0,0,1,.23.91A.67.67,0,0,1,342,304.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.44,316.39a.58.58,0,0,1-.33-.1c-5.81-3.46-10.61-6.78-10.61-12.29a.66.66,0,0,1,1.32,0c0,4.83,4.32,7.79,10,11.16a.66.66,0,0,1-.34,1.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.9,328.72a.74.74,0,0,1-.34-.1c-5.8-3.46-10.6-6.78-10.6-12.29a.66.66,0,1,1,1.32,0c0,4.83,4.32,7.79,10,11.16a.66.66,0,0,1,.23.9A.65.65,0,0,1,384.9,328.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.36,341A.72.72,0,0,1,406,341c-5.8-3.46-10.6-6.78-10.6-12.29a.66.66,0,0,1,1.32,0c0,4.83,4.32,7.79,10,11.16a.66.66,0,0,1,.23.9A.66.66,0,0,1,406.36,341Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.63,377.94l3.21,9.2a10.22,10.22,0,0,0,3.94,4.75l31.83,18.29a6.33,6.33,0,0,0,5.72,0l69.39-39.87a6.3,6.3,0,0,0,2.86-4.93V347.29a6.3,6.3,0,0,0-2.86-4.93L236,240.83a6.33,6.33,0,0,0-5.72,0L160.93,280.7a6.3,6.3,0,0,0-2.86,4.93v5.76a6.28,6.28,0,0,0,2.86,4.93l133.76,76.87A10.16,10.16,0,0,1,298.63,377.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.33,385.52l69.39-39.87c1.58-.91,1.58-2.38,0-3.29L236,240.83a6.33,6.33,0,0,0-5.72,0L160.93,280.7c-1.58.91-1.58,2.38,0,3.29L337.61,385.52A6.33,6.33,0,0,0,343.33,385.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.18,241.47a4.59,4.59,0,0,1,2.2.5L412.06,343.5c.43.25.52.46.52.5s-.09.26-.52.5l-69.39,39.88a5.09,5.09,0,0,1-4.4,0L161.59,282.85c-.43-.25-.53-.46-.53-.5s.1-.26.53-.5L231,242a4.63,4.63,0,0,1,2.21-.5m0-1.32a5.9,5.9,0,0,0-2.86.68L160.93,280.7c-1.58.91-1.58,2.38,0,3.29L337.61,385.52a6.35,6.35,0,0,0,5.72,0l69.39-39.87c1.58-.91,1.58-2.38,0-3.29L236,240.83a5.93,5.93,0,0,0-2.86-.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.63,388.05a.62.62,0,0,1-.32-.09L155.77,284.22a.65.65,0,0,1-.24-.9.66.66,0,0,1,.9-.25L337,386.82a.66.66,0,0,1,.25.9A.68.68,0,0,1,336.63,388.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.4,301.22a.66.66,0,0,1-.33-.09c-5.8-3.47-10.61-6.79-10.61-12.3a.66.66,0,1,1,1.32,0c0,4.83,4.32,7.79,10,11.16a.66.66,0,0,1,.23.91A.67.67,0,0,1,175.4,301.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.86,313.55a.58.58,0,0,1-.33-.1c-5.8-3.46-10.61-6.78-10.61-12.29a.66.66,0,0,1,1.32,0c0,4.83,4.32,7.79,10,11.16a.66.66,0,0,1,.23.91A.67.67,0,0,1,196.86,313.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.32,325.88a.58.58,0,0,1-.33-.1c-5.81-3.46-10.61-6.78-10.61-12.29a.66.66,0,1,1,1.32,0c0,4.83,4.32,7.79,10,11.16a.66.66,0,0,1-.34,1.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.78,338.21a.63.63,0,0,1-.34-.1c-5.8-3.46-10.6-6.78-10.6-12.29a.66.66,0,0,1,1.32,0c0,4.83,4.32,7.79,10,11.16a.66.66,0,0,1,.23.9A.65.65,0,0,1,239.78,338.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.24,350.53a.72.72,0,0,1-.34-.09c-5.8-3.46-10.6-6.78-10.6-12.29a.66.66,0,0,1,1.32,0c0,4.83,4.31,7.79,10,11.16a.66.66,0,0,1,.23.9A.66.66,0,0,1,261.24,350.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.7,362.86a.72.72,0,0,1-.34-.09c-5.8-3.47-10.6-6.78-10.6-12.29a.66.66,0,0,1,1.32,0c0,4.83,4.32,7.79,10,11.16a.66.66,0,0,1-.34,1.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.16,375.19a.72.72,0,0,1-.34-.09c-5.8-3.47-10.6-6.78-10.6-12.3a.66.66,0,0,1,1.32,0c0,4.83,4.31,7.8,10,11.17a.66.66,0,0,1,.23.9A.67.67,0,0,1,304.16,375.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.62,387.52a.69.69,0,0,1-.34-.09c-5.8-3.47-10.6-6.78-10.6-12.3a.66.66,0,1,1,1.32,0c0,4.83,4.31,7.8,10,11.17a.65.65,0,0,1,.22.9A.64.64,0,0,1,325.62,387.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.86,230.85,222.38,238c-8.5,10.11-17.94,18.47-27.89,24.18-8.7,5-17,7.54-24.72,7.54-.82,0-1.64,0-2.44-.1L159.76,274l171.67,98.64c10.82,3,23.71,1,37.55-6.94s26.73-20.74,37.55-36.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,336.68c-8.49,10.12-17.93,18.47-27.88,24.18-8.7,5-17,7.54-24.72,7.54-.83,0-1.64,0-2.44-.1l-7.57,4.36c10.82,3,23.71,1,37.55-6.94s26.73-20.74,37.55-36.23Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339 368.3 167.33 269.66 159.76 274.02 331.43 372.66 339 368.3",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.86 230.84 222.38 238.03 394.04 336.68 406.53 329.49 234.86 230.84",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.88,367.79a.63.63,0,0,1-.33-.09l-161-92.51a.65.65,0,0,1-.24-.9.66.66,0,0,1,.9-.24l161,92.51a.66.66,0,0,1-.33,1.23Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.88,367.79a.63.63,0,0,1-.33-.09l-161-92.51a.65.65,0,0,1-.24-.9.66.66,0,0,1,.9-.24l161,92.51a.66.66,0,0,1-.33,1.23Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,330.67a.62.62,0,0,1-.33-.08l-161-92.52a.64.64,0,0,1-.24-.89.65.65,0,0,1,.9-.24l161,92.51a.65.65,0,0,1-.33,1.22Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,330.67a.62.62,0,0,1-.33-.08l-161-92.52a.64.64,0,0,1-.24-.89.65.65,0,0,1,.9-.24l161,92.51a.65.65,0,0,1-.33,1.22Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.77,341.87l-166.1-95.45-40.5,23.25v2.1l166.11,95.45L386.77,344Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.17 269.67 220.67 246.42 386.77 341.87 346.28 365.12 180.17 269.67",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.28 367.22 346.28 365.12 386.77 341.87 386.77 343.97 346.28 367.22",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pillow--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237,259.2c0-1.38-2.08-3.7-4.65-5.17L222,248.09a7,7,0,0,0-3.57-1.15h0c-2.22,0-11.1,4.27-15.46,6.78s-13.88,8.54-15.36,11.1c-.48.83,16.68,13.24,18.78,12.8,4.67-1,13.11-5,17.44-7.6,7.08-4.3,11.09-7.88,12.5-9.4C237,259.88,237,259.5,237,259.2Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.06,270.61l10.33,5.93c2.57,1.48,4.65,1.55,4.65.17s-2.08-3.7-4.65-5.18l-10.33-5.93c-2.57-1.48-4.65-1.55-4.65-.17S189.49,269.13,192.06,270.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-1--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.31,150.07a2.23,2.23,0,0,0,2,0l47.83-27.61a2.33,2.33,0,0,0,1.05-1.82V76.39a2,2,0,0,0-3-1.75l-47.82,27.62a2.33,2.33,0,0,0-1.05,1.82v44.21A2.26,2.26,0,0,0,268.31,150.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.28,74.61a1.7,1.7,0,0,1,.85.19,2,2,0,0,1,.87,1.59V120.6a2.1,2.1,0,0,1-.94,1.62l-24.22,14-23.61,13.63a1.92,1.92,0,0,1-1,.23,1.81,1.81,0,0,1-.85-.19,2.06,2.06,0,0,1-.87-1.59V104.08a2.09,2.09,0,0,1,.94-1.62l47.83-27.62a1.92,1.92,0,0,1,1-.23m0-.23a2.3,2.3,0,0,0-1.08.26l-47.82,27.62a2.33,2.33,0,0,0-1.05,1.82v44.21a2.26,2.26,0,0,0,1,1.78,2,2,0,0,0,1,.23,2.19,2.19,0,0,0,1.08-.27l47.83-27.61a2.33,2.33,0,0,0,1.05-1.82V76.39a2.26,2.26,0,0,0-1-1.78,2,2,0,0,0-1-.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.35,150l47.83-27.62a2.31,2.31,0,0,0,1.05-1.81V76.39c0-.67-.47-1-1.05-.61L270.35,103.4a2.32,2.32,0,0,0-1.05,1.82v44.21C269.3,150.1,269.77,150.37,270.35,150Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.68,144.92V108.09a1.4,1.4,0,0,1,.65-1.12l45.86-26.48c.36-.21.65,0,.65.37v36.83a1.43,1.43,0,0,1-.65,1.12l-45.86,26.48C271,145.49,270.68,145.33,270.68,144.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.63,103l2,1.14a2.4,2.4,0,0,0-.31,1v44.21c0,.61.41.95,1.05.6a2.23,2.23,0,0,1-2,0,2,2,0,0,1-1-1.65V104.08A2.31,2.31,0,0,1,267.63,103Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.68,134.08l2.38-1.36c.21-.12.38,0,.38.19a.82.82,0,0,1-.38.64l-2.38,1.37c-.21.12-.38,0-.38-.2A.84.84,0,0,1,293.68,134.08Z",
    style: {
      fill: "#845EC2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.17,338.63a7.76,7.76,0,0,1-.8,3.68,9.1,9.1,0,0,1-6.5,4.58c-2.91.57-6.15-1.63-8.77-2.67-3.9-1.56-8.12-2.1-12.11-3.36a67.36,67.36,0,0,1-6.7-2.62q-10.1-4.33-20.16-8.69a103.16,103.16,0,0,0,12.16,10.92c3.64,2.77,8.59,6.77,13.45,6.58a18.46,18.46,0,0,0,4.75-.95,2.85,2.85,0,0,1,1.7-.16,2.4,2.4,0,0,1,1,.82c3.78,4.79-1.17,12.7-6.76,13.16-2.06.18-3.9-1.18-5.64-2.33-9-5.89-20.2-7.31-29.6-12.47-1.84-1-3.57-2.17-5.31-3.32-1.43-.94-2.57-2-3.94-3-2.73-2.06-6.06-3.17-9.29-4.22-6.52-2.14-13-4.16-19.33-6.91a70.34,70.34,0,0,1-18.13-10.84c-4.62-4-9.06-8.13-14.54-11a28.59,28.59,0,0,0-6.55-2.47,21.38,21.38,0,0,0-3.4-.45c-.49,0-3.23.29-3.48,0a65.57,65.57,0,0,0,13.95,11.15c5.72,3.54,11.79,6.48,17.81,9.46,2.78,1.38,5.45,3.17,8.41,4.12s6,1.14,8.92,1.81c1.6.35.91,1.63-.21,2.15a5.54,5.54,0,0,0-.85.41c-.31.22-.5.58-.8.82-.64.49-1.57.42-2.21.88a8.35,8.35,0,0,1-.8.67,2.4,2.4,0,0,1-.92.23c-2.21.26-4.9.82-7.1.3a24.46,24.46,0,0,1-5-2.27c-1.88-.95-3.9-1.51-5.83-2.36-4.76-2.1-9.47-4.19-14.26-6.21A135.4,135.4,0,0,1,228,316.31c-2.29-1.35-3.19-3.77-4.68-5.85a86.22,86.22,0,0,1-5.78-8.65c-1.94-3.57-2.91-8-4.1-11.91-1.36-4.41.85-7.16,3.56-10.43a4.62,4.62,0,0,0,.82-1.3c.51-1.49-.69-3.11-2.15-3.73a15.16,15.16,0,0,0-4.67-.74,16.22,16.22,0,0,1-5.06-1.4,16.5,16.5,0,0,1-4.35-2.94c-1.18-1.13-2.26-2.49-3.34-3.57a8,8,0,0,1-2.2-4.87,7.67,7.67,0,0,1,1.85-5.44c1.39-1.78,2.57-3.74,3.93-5.53a9.55,9.55,0,0,1,5.48-3.84,13.87,13.87,0,0,1,7,.28,34.7,34.7,0,0,1,7.26,3.05c2.94,1.64,5.49,4.49,5.63,7.85,0,1.16-.19,2.31-.24,3.46a5,5,0,0,0,.79,3.31,3.2,3.2,0,0,0,2.55,1.22,7.86,7.86,0,0,0,2.34-.62,20.35,20.35,0,0,1,5.35-1.14,7.06,7.06,0,0,1,4.75.9c3.43,1.88,6.85,3.74,10.3,5.59q10.3,5.55,20.66,11c13.75,7.37,27.45,14.85,40.72,23.07l2.18,1.37c12.28,7.71,24.2,16.12,37.32,22.3,3.81,1.8,7.58,3.6,11.48,5.14,1.84.71,4.08.59,6.05.83l1.69.24h0Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.49,304.94a180.6,180.6,0,0,0,22,10.17c9,3.42,15.58,5.78,19.62,7.16s6.18,4.65,10.74,7.21a63.22,63.22,0,0,0,16.91,6.73c7.44,1.69,12.4,2.84,16.35,4.48,3.21,1.33,6.69,5.77,10.35,2.31,2.49-2.37,1.77-5.43,3.51-8.86,1-2,2.25-3.88,3.08-5.95a6.94,6.94,0,0,0,.46-2.59,5,5,0,0,0-.13-1.34c-.09-.33-.32-.62-.43-.95a4.57,4.57,0,0,1-.12-1.05,2.18,2.18,0,0,0-1.43-1.76.62.62,0,0,1-.29-.15.7.7,0,0,1-.09-.24,1.24,1.24,0,0,0-1.23-.83,1.76,1.76,0,0,0-1.4-1.24,2.82,2.82,0,0,0-.64-1.49,2.1,2.1,0,0,0-1.44-.73c-.52,0-.77.45-1,.84a5.22,5.22,0,0,0-.59,1.52,27.47,27.47,0,0,1-.93,3.65c-.42,1-.61,2.28-1.1,3.29-.88,1.81-1.82,4.55-4.27,5-2,.35-9.37-4.21-17.19-9.72-7.41-5.23-14.22-9.85-18.88-13.05s-33-18.7-33-18.7Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.16,323a4.32,4.32,0,0,0-2.43-1.58c-.45-.13-.9-.24-1.36-.33a7.69,7.69,0,0,0-.94-.16,1.68,1.68,0,0,0-.83.12c-.08,0-.07.23,0,.23a15.19,15.19,0,0,1,2.83.61,8.58,8.58,0,0,1,2.62,1.26C383.17,323.19,383.2,323,383.16,323Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.52,325.6a5,5,0,0,0-.13-1.34c-.09-.33-.32-.62-.43-.95a3.41,3.41,0,0,1-.11-.9.68.68,0,0,0-.2.07c-.42.26-.48.83-.54,1.31-.26,2.26-1.48,3.22-3.26,4.32-1.42.89-3.17,1.74-3.53,3.55-.24,1.2.41,2.55.56,3.76.22,1.74.92,3.5.39,5.26-.71,2.39-2.91,2.92-5.08,3a4.25,4.25,0,0,0,5.28-.67c2.49-2.37,1.77-5.43,3.51-8.86,1-2,2.25-3.88,3.08-5.95A6.94,6.94,0,0,0,384.52,325.6Z",
    style: {
      fill: "#f0997a",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.48,336.37a42.48,42.48,0,0,1-20.17-12.08c-2.8-2.72-7.61-3.82-10.28-5.82s-31.81-19.56-32.08-20l-7.46,6.45,12,6c3,1.37,6.38,2.79,10,4.18,9,3.42,15.58,5.78,19.62,7.16s6.18,4.65,10.74,7.21a63.22,63.22,0,0,0,16.91,6.73l.72.16Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.51,312.06a180.08,180.08,0,0,0,21.32,11.54c8.73,4,15.19,6.76,19.12,8.4s5.88,5,10.27,7.87a67.08,67.08,0,0,0,17,7.31c7.31,2.16,12.25,4.67,14.94,6.86s6.89,5.31,10.76,2.08c2.64-2.2,2.12-5.3,4.07-8.62,2.62-4.44,5.3-7.05,4.47-12.59,0-.27.32-.7.42-1a8.56,8.56,0,0,0,.35-1.12,3.82,3.82,0,0,0,.06-1.87,1.54,1.54,0,0,0-2.78-.49,1.36,1.36,0,0,1-.38.41,1.2,1.2,0,0,1-.5.09A2,2,0,0,0,361,332a.69.69,0,0,1-.23.3.63.63,0,0,1-.36,0,1.63,1.63,0,0,0-1.4.5,1.83,1.83,0,0,1-.48.48,1.42,1.42,0,0,1-.71.1c-2.36.09-2.89,2.79-3.83,4.47s-2.3,4.3-4.21,5.13c-1.69.74-9.23-5.91-16.68-11.08s-13.56-10.73-18-14.21S283.4,297,283.4,297Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.59,334.24a6.23,6.23,0,0,0-3.54.36,11.84,11.84,0,0,0-1.72.73c-.68.36-1.29.79-1.93,1.2,0,0,0,.14,0,.12.57-.25,1.16-.46,1.74-.72s1.22-.51,1.85-.72a9.62,9.62,0,0,1,1.74-.43c.62-.09,1.24,0,1.85-.08C364.82,334.68,364.77,334.29,364.59,334.24Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.21,338.83c-1.68,1.51-3.42,1.7-5.54,2.21a4.48,4.48,0,0,0-3.05,1.94,4.56,4.56,0,0,0,.35,4.14,22.38,22.38,0,0,1,2,3.83,3.39,3.39,0,0,1,.11,1.61,3.56,3.56,0,0,1-.64,1.4,6.9,6.9,0,0,1-6.19,2.8,5.84,5.84,0,0,0,6.66-.64c2.64-2.2,2.12-5.3,4.07-8.62,2.29-3.88,4.63-6.37,4.62-10.65A10.06,10.06,0,0,0,363.21,338.83Z",
    style: {
      fill: "#f0997a",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,347.5c1.25-2.21,2.82-4.26,3.77-6.62a10.64,10.64,0,0,0,.73-3.7,13.09,13.09,0,0,0-.11-1.88,2.44,2.44,0,0,1,0-.51,1.44,1.44,0,0,1,.2-.49,2.6,2.6,0,0,0,.21-.4l.14-.45a5.22,5.22,0,0,0,.34-1.81,1.64,1.64,0,0,0-.74-1.49,1.33,1.33,0,0,0-1.57.16,2.13,2.13,0,0,0-.29.31,1.37,1.37,0,0,1-.37.41,1.1,1.1,0,0,1-.55.12,2,2,0,0,0-.42.08,1.9,1.9,0,0,0-.73.45,1.7,1.7,0,0,0-.26.34c-.08.11-.09.28-.31.46a.83.83,0,0,1-.6.06,1.12,1.12,0,0,0-.41,0,1.43,1.43,0,0,0-.72.4c-.09.09-.18.23-.31.36a.93.93,0,0,1-.52.29c-.39,0-.66,0-.95.09a2.51,2.51,0,0,0-1.45.93,21.83,21.83,0,0,0-1.73,3.34,27.41,27.41,0,0,1-2,3.29,7.6,7.6,0,0,1-1.36,1.42,4.46,4.46,0,0,1-.86.54,1.23,1.23,0,0,1-.58.12,2.17,2.17,0,0,1-.53-.1,14.81,14.81,0,0,1-3.41-1.88c-4.2-2.92-8.15-6.13-12.33-9s-8.18-6.1-12.09-9.36c-2-1.63-3.91-3.28-5.9-4.85s-4.13-2.95-6.23-4.38c-4.22-2.85-8.48-5.63-12.75-8.42L283.4,297c8.66,5.37,17.28,10.78,25.8,16.38,2.12,1.41,4.26,2.79,6.3,4.36s3.95,3.22,5.92,4.83c3.92,3.25,7.91,6.41,12.09,9.3s8.13,6.16,12.29,9.07a14.76,14.76,0,0,0,3.25,1.82.94.94,0,0,0,.74,0,3.81,3.81,0,0,0,.76-.47,7.58,7.58,0,0,0,1.27-1.32,30.51,30.51,0,0,0,2-3.22,21.52,21.52,0,0,1,1.82-3.39,3,3,0,0,1,1.71-1.07c.34-.06.71-.05,1-.08s.35-.24.61-.52a1.77,1.77,0,0,1,.93-.5,1.64,1.64,0,0,1,.54,0c.19,0,.32.05.33,0s.11-.17.2-.33a2.59,2.59,0,0,1,.32-.42,2.25,2.25,0,0,1,.89-.53c.33-.12.75-.06.9-.16s.34-.47.62-.68a1.7,1.7,0,0,1,2-.18,2,2,0,0,1,.88,1.78,5.37,5.37,0,0,1-.38,1.91L366,334a3,3,0,0,1-.24.44,1.23,1.23,0,0,0-.18.39c0,.08,0,.3,0,.44a11.18,11.18,0,0,1,.08,1.92,10.85,10.85,0,0,1-.81,3.74A57.16,57.16,0,0,1,361,347.5Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.53,280.92c7.06,3.05,18.73,6.62,23.33,8.27a64,64,0,0,1,7.34,3.22c1.86.95,3.83,2.36,5.87,2.86a14.85,14.85,0,0,0,3.11.44,5.12,5.12,0,0,0,3-.59c.14-.09.28-.2.43-.28a5,5,0,0,1,1-.19,1.78,1.78,0,0,0,1.12-.79,5.27,5.27,0,0,1,.4-.64c.41-.44,1.16-.41,1.62-.81s.47-.89.78-1.28c.53-.67,1.57-.75,2.11-1.4a.82.82,0,0,0,.21-.53c0-.44-.53-.68-1-.79-.82-.22-1.66-.38-2.5-.53-1.29-.24-2.59-.44-3.85-.79-.89-.25-4.09-1.3-5-2.08,1.48-.19,2.24.32,4.27-.4a3.1,3.1,0,0,0,1.71-1.39.67.67,0,0,0,.1-.34c0-.5-.69-.62-1.19-.61-2,0-3.82-.87-5.79-1.17-2.91-.45-6.46,1-9.71-.14-2.2-.75-23.91-11.53-23.91-11.53",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.25,260.18a22.69,22.69,0,0,1,20.36,1.5c6.69,3.8,15.93,12.54,15.93,12.54l-9.15,6.31Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.25,260.18a22.69,22.69,0,0,1,20.36,1.5c6.69,3.8,15.93,12.54,15.93,12.54l-9.15,6.31Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,272.37c-3.54,3.85-7.8,6.7-6.18,11.1s11.83,11.82,17.28,14.15,13.15,2.8,18,5.9c2.73,1.73,4.2,6.18,18.34,14.16,8.54,4.82,28.88,14.81,28.88,14.81s-3-4.86,2-12.43,21.16-20.57,28.19-16.85c-9-5.45-30.28-18.15-35.52-21.27-7.06-4.21-24.3-16.18-34.91-20.33-7.32-2.87-14.81-2.5-19.18-.6a22.36,22.36,0,0,0-6,3.48Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,272.37c-3.54,3.85-7.8,6.7-6.18,11.1s11.83,11.82,17.28,14.15,13.15,2.8,18,5.9c2.73,1.73,4.2,6.18,18.34,14.16,8.54,4.82,28.88,14.81,28.88,14.81s-3-4.86,2-12.43,21.16-20.57,28.19-16.85c-9-5.45-30.28-18.15-35.52-21.27-7.06-4.21-24.3-16.18-34.91-20.33-7.32-2.87-14.81-2.5-19.18-.6a22.36,22.36,0,0,0-6,3.48Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.17,267.44c1.19.34,2.43.55,3.6.79a54.68,54.68,0,0,1,8.39,2.07c0-.26,1.86-15.69,2-19.47a13.29,13.29,0,0,1,.51-4.58,4.43,4.43,0,0,0-.71-4c-1.68-2.33-4.45-4.18-7.32-4a15.29,15.29,0,0,0-6.41,1.83,23,23,0,0,0-5.94,5.4,14.31,14.31,0,0,0-2.58,6.59c-.34,2.57,0,5.4,1.77,7.32a1.35,1.35,0,0,1,.33.46,7.35,7.35,0,0,0,2,5A8.94,8.94,0,0,0,205.17,267.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.84,271.18c2.86-.83,2.43-3.1,2.43-3.1l6.72,5.27c4.43,0,11.84-4.65,15.9-6.44a14.06,14.06,0,0,0-6.26-2L228.37,263a14.58,14.58,0,0,0,2.13-2.88,9.31,9.31,0,0,0,.81-2.22c.32-1.57-.66-3.53-2-5.06-3.47-4-4.65-5.43-7.33-6.53-1.09-.45-.91-1.45-2-2.15a16,16,0,0,0-5.87-2.36c-3.87.4-2.29,1.93-4,4.22-1.26,1.72-5.88,3-4.42,6a7,7,0,0,1,2.18,3.58,5.51,5.51,0,0,1,.05,2.58c2,1.67,2.46,2.17,3.08,3.24a1.56,1.56,0,0,1-.35,2.38c-.55.36-1.92-.11-3-.15a2.85,2.85,0,0,0-2.26,4.4A5.82,5.82,0,0,0,211.84,271.18Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.36,263c-1.83,2-5.52,5.17-7.67,5.28s-5.8-1.31-5.8-1.31,3.71,2.14,5.81,2.42,4.1-1.12,5.53-2.16a28.75,28.75,0,0,0,3.39-3.2Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.91,251.15l-1.94,2a1.47,1.47,0,0,1,0-2A1.37,1.37,0,0,1,212.91,251.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.43,246.82l2.14-1.81a1.47,1.47,0,0,0-2-.16A1.37,1.37,0,0,0,216.43,246.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.38,255.54a1.14,1.14,0,1,0-.19-1.6A1.15,1.15,0,0,0,213.38,255.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.76,258.86a.89.89,0,0,0,1.1-1.4.89.89,0,0,0-1.25.15A.9.9,0,0,0,221.76,258.86Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.32,249.28a1.14,1.14,0,1,0-.2-1.6A1.15,1.15,0,0,0,219.32,249.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.75 250.77 222.31 255.32 214.76 250.28 223.75 250.77",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.93,326.47c-1.28-.31-2.56-.59-3.8-1a20.64,20.64,0,0,1-4.87-2.38c1.5-.1,2.23.46,4.29-.14a3,3,0,0,0,1.79-1.28.7.7,0,0,0,.12-.34c0-.5-.65-.65-1.15-.68-2-.12-3.76-1.09-5.71-1.51-2.88-.62-5.44.19-8.61-1.12-2.15-.88-23.2-14-23.2-14s-5.07-6.64-12-15.46c-5.65-7.19-8.41-9.57-12.21-10.44-3.63,2.87-5.18,5.19-4.38,9.25.66,3.33,2.82,6.4,5.5,10.49a109.07,109.07,0,0,0,9.81,13.31c2.35,2.83,3.26,3.2,8,5.59,6.87,3.47,18.31,7.73,22.8,9.66a62.14,62.14,0,0,1,7.13,3.65c1.81,1.06,3.69,2.58,5.69,3.2a14.78,14.78,0,0,0,3.08.63,5.18,5.18,0,0,0,3-.4,4,4,0,0,1,.45-.26,4.91,4.91,0,0,1,1-.13,1.78,1.78,0,0,0,1.18-.72,3.72,3.72,0,0,1,.43-.61c.44-.42,1.18-.34,1.66-.72s.52-.85.86-1.23c.57-.63,1.61-.65,2.19-1.27a.84.84,0,0,0,.24-.52c0-.44-.49-.7-.91-.84C282.58,326.88,281.76,326.67,280.93,326.47Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.79,276.7c-2.82,2.53-6.8,7.21-5.24,12.26,1.85,6,8.33,19.49,8.33,19.49s8.43.35,12.25-1.36c5.94-2.66,7.6-5.29,7.6-5.29l-11.46-16.07S221.83,277.9,215.79,276.7Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.79,276.7c-2.82,2.53-6.8,7.21-5.24,12.26,1.85,6,8.33,19.49,8.33,19.49s8.43.35,12.25-1.36c5.94-2.66,7.6-5.29,7.6-5.29l-11.46-16.07S221.83,277.9,215.79,276.7Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.73,389.56v59.07a1,1,0,0,1-.57.93,2.19,2.19,0,0,1-1.08.27,2.14,2.14,0,0,1-1.08-.27,1,1,0,0,1-.58-.93V389.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.27,433.37h0c-4.87-2.81-7.56-6.59-7.56-10.64s2.69-7.83,7.56-10.65c9.82-5.67,25.79-5.67,35.61,0,4.87,2.82,7.56,6.6,7.56,10.65s-2.69,7.83-7.56,10.64-11.36,4.26-17.81,4.25S127.18,436.21,122.27,433.37Zm.64-20.18c-4.46,2.58-6.92,6-6.92,9.54s2.46,7,6.92,9.54h0c9.47,5.46,24.86,5.46,34.33,0,4.46-2.58,6.92-6,6.92-9.54s-2.46-7-6.92-9.54c-4.74-2.73-11-4.1-17.17-4.1S127.64,410.46,122.91,413.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.38,439l6.19-54.26-.13-.37h3.5l-6.27,54.78a1.12,1.12,0,0,1-.57.85,2.37,2.37,0,0,1-2.16,0A1,1,0,0,1,115.38,439Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.55,439l-6.19-54.26.13-.37H155l6.27,54.78a1.12,1.12,0,0,0,.57.85,2.16,2.16,0,0,0,1.08.26A2.18,2.18,0,0,0,164,440,1,1,0,0,0,164.55,439Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.09,368.15c-8.71-5-22.84-5-31.56,0-4.36,2.52-6.53,5.82-6.53,9.12v4c0,3.3,2.17,6.6,6.53,9.12,8.72,5,22.85,5,31.56,0,4.36-2.52,6.54-5.82,6.54-9.12v-4.05C162.63,374,160.45,370.67,156.09,368.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.09,366.19c-8.71-5-22.84-5-31.56,0C120.17,368.7,118,372,118,375.3v4.05c0,3.3,2.17,6.59,6.53,9.11,8.72,5,22.85,5,31.56,0,4.36-2.52,6.54-5.81,6.54-9.11V375.3C162.63,372,160.45,368.7,156.09,366.19Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.53,384.41c-8.72-5-8.72-13.19,0-18.22s22.85-5,31.56,0,8.72,13.19,0,18.22S133.25,389.44,124.53,384.41Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.53,384.41c-8.72-5-8.72-13.19,0-18.22s22.85-5,31.56,0,8.72,13.19,0,18.22S133.25,389.44,124.53,384.41Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatients2);
export default __webpack_public_path__ + "static/media/Patients2.90190747f16742f4e7f8af53e10dcfed.svg";
export { ForwardRef as ReactComponent };